module.exports = {
	"contractName": "CrosslinkShip",
	"abi": [
		{
			"constant": true,
			"inputs": [],
			"name": "htcIsHauled",
			"outputs": [
				{
					"name": "",
					"type": "bool"
				}
			],
			"payable": false,
			"stateMutability": "view",
			"type": "function"
		},
		{
			"constant": true,
			"inputs": [],
			"name": "anchor",
			"outputs": [
				{
					"name": "",
					"type": "address"
				}
			],
			"payable": false,
			"stateMutability": "view",
			"type": "function"
		},
		{
			"constant": false,
			"inputs": [],
			"name": "sailAway",
			"outputs": [],
			"payable": false,
			"stateMutability": "nonpayable",
			"type": "function"
		},
		{
			"constant": false,
			"inputs": [],
			"name": "pullAnchor",
			"outputs": [],
			"payable": false,
			"stateMutability": "nonpayable",
			"type": "function"
		},
		{
			"constant": false,
			"inputs": [
				{
					"name": "blockNumber",
					"type": "uint256"
				}
			],
			"name": "dropShipAnchor",
			"outputs": [
				{
					"name": "addr",
					"type": "address"
				}
			],
			"payable": false,
			"stateMutability": "nonpayable",
			"type": "function"
		}
	],
	"bytecode": "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",
	"deployedBytecode": "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",
	"sourceMap": "26:2028:3:-;;;79:5;53:31;;-1:-1:-1;;;;;;88:27:3;;;26:2028;5:2:-1;;;;30:1;27;20:12;5:2;26:2028:3;;;;;;;",
	"deployedSourceMap": "26:2028:3:-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;534:1000;;8:9:-1;5:2;;;30:1;27;20:12;5:2;-1:-1;534:1000:3;;;;;;;;;-1:-1:-1;;;;;534:1000:3;;;;;;;;;;;;;;53:31;;8:9:-1;5:2;;;30:1;27;20:12;5:2;53:31:3;;;;;;;;;;;;;;;;;;;;;;120:256;;8:9:-1;5:2;;;30:1;27;20:12;5:2;120:256:3;;;;;;380:150;;8:9:-1;5:2;;;30:1;27;20:12;5:2;380:150:3;;;;88:27;;8:9:-1;5:2;;;30:1;27;20:12;5:2;88:27:3;;;;534:1000;595:12;803:19;;:::i;:::-;974:12;1043:19;;:::i;:::-;1208:16;;;713:5;698:12;:20;684:34;;676:43;;;;;;835:6;828:13;;:4;847;;:18;;;878:4;871;;;:11;895:4;888;;;:11;912:4;905;;;:11;929:4;922;;;:11;946:4;939;;;:11;963:4;956;;;:11;989;828:1;989:8;:11::i;:::-;1075:1;1068:8;;1089:4;1068;1082;;:11;1099:4;;;:11;;;1123:6;1116:4;;;:13;1142:4;1135;;;:11;1159:6;1152:4;;;:13;1178:6;1171:4;;;:13;1197:4;1190;;;:11;974:26;-1:-1:-1;1227:11:3;1068:1;1227:8;:11::i;:::-;1208:30;;1257:17;1265:8;1257:7;:17::i;:::-;1244:30;;1302:2;1297;:7;1280:24;;1363:4;1357:11;1405:8;1382:21;1375:39;1475:2;1466:6;1443:21;1439:34;1436:1;1429:49;1421:57;-1:-1:-1;;;;;;;1498:11:3;;;;1490:20;;;;;;-1:-1:-1;;1516:6:3;:13;;-1:-1:-1;;1516:13:3;;-1:-1:-1;;;;;1516:13:3;;;;;;-1:-1:-1;1516:13:3;;;-1:-1:-1;;;;534:1000:3:o;53:31::-;;;;;;:::o;120:256::-;182:12;161:6;;182:12;;161:6;;;-1:-1:-1;;;;;161:6:3;:13;;153:22;;;;;;-1:-1:-1;;197:1:3;216:6;;;;;-1:-1:-1;;;;;216:6:3;253:14;;;282:8;;278:69;;;300:8;;;278:69;-1:-1:-1;;353:11:3;:18;;-1:-1:-1;;353:18:3;367:4;353:18;;;120:256::o;380:150::-;419:6;;;;;-1:-1:-1;;;;;419:6:3;:14;415:111;;451:6;;;:13;;:6;;;;-1:-1:-1;;;;;451:6:3;;:13;:6;:13;:6;;:13;;;;;443:22;;;;;;;;380:150::o;88:27::-;;;;;;-1:-1:-1;;;;;88:27:3;;:::o;1585:187::-;1645:12;1682:13;1665:103;1701:1;1697;:5;1665:103;;;1747:13;1755:4;1747:7;:13::i;:::-;1743:1;:17;1725:6;1736:1;1732;:5;1725:13;;;;;;;;;;;;;:36;;;;;;1717:44;;;;;-1:-1:-1;;1704:3:3;1665:103;;;1585:187;;;;:::o;1776:276::-;1863:13;;;1873:2;1863:13;;;;;;;;;1831:7;;1846:14;;1831:7;;1863:13;;;17:15:-1;;105:10;1863:13:3;88:34:-1;136:17;;-1:-1;1863:13:3;1846:30;;1918:5;1913:2;1910:1;1906:10;1899:25;1951:1;1940:12;;1935:99;1958:1;:8;1954:1;:12;;;1935:99;;;1985:1;1987;1985:4;;;;;;;;;;;;;;;;;;;;;;;:9;;;1981:47;;2018:1;2013:2;:6;2006:13;;;;;;1981:47;1968:3;;1935:99;;;2046:1;2039:8;;1776:276;;;;;;:::o;26:2028::-;;;;;;;;;;;;29:2:-1;21:6;17:15;117:4;105:10;97:6;88:34;-1:-1;26:2028:3;;;-1:-1:-1;;26:2028:3:o",
	"source": "pragma solidity ^0.4.24;\n\ncontract CrosslinkShip {\n  bool public htcIsHauled = false;\n  address public anchor = 0x0;\n\n  function sailAway() public {\n    require(anchor != 0x0);\n\n    uint256 size = 0;\n    address a = anchor;\n    assembly {\n      size := extcodesize(a)\n    }\n    if (size > 0) {\n      revert(); // it is too early to sail away\n    }\n\n    htcIsHauled = true;\n  }\n\n  function pullAnchor() public {\n    if (anchor != 0x00) {\n      require(anchor.call()); // raise the anchor if the ship is ready to sail away\n    }\n  }\n\n  function dropShipAnchor(uint256 blockNumber) public returns (address addr) {\n    // the ship will be able to sail away in 50k blocks time\n    require(blockNumber > block.number + 50000);\n\n    // if(block.number < blockNumber) { throw; }\n    // suicide(msg.sender);\n    uint256[8] memory a;\n    a[0] = 0x6300;\n    a[1] = blockNumber;\n    a[2] = 0x43;\n    a[3] = 0x10;\n    a[4] = 0x58;\n    a[5] = 0x57;\n    a[6] = 0x33;\n    a[7] = 0xff;\n\n    uint256 code = assemble(a);\n\n    // init code to deploy contract\n    uint256[8] memory b;\n    b[0] = 0;\n    b[1] = 0x6a;\n    b[2] = code;\n    b[3] = 0x6000;\n    b[4] = 0x52;\n    b[5] = 0x600b;\n    b[6] = 0x6015;\n    b[7] = 0xf3;\n\n    uint256 initcode = assemble(b);\n    uint256 sz = getSize(initcode);\n    uint256 offset = 32 - sz;\n\n    assembly {\n      let solidity_free_mem_ptr := mload(0x40)\n      mstore(solidity_free_mem_ptr, initcode)\n      addr := create(0, add(solidity_free_mem_ptr, offset), sz)\n    }\n\n    require(addr != 0x0);\n    anchor = addr;\n  }\n\n  ///////////////// HELPERS /////////////////\n\n  function assemble(uint256[8] chunks) internal pure returns (uint256 code) {\n    for (uint256 i = chunks.length; i > 0; i--) {\n      code ^= chunks[i - 1] << (8 * getSize(code));\n    }\n  }\n\n  function getSize(uint256 chunk) internal pure returns (uint256) {\n    bytes memory b = new bytes(32);\n    assembly {\n      mstore(add(b, 32), chunk)\n    }\n    for (uint32 i = 0; i < b.length; i++) {\n      if (b[i] != 0) {\n        return 32 - i;\n      }\n    }\n    return 0;\n  }\n}\n",
	"sourcePath": "/Users/billhsu/Desktop/work/github/cypherpunks-ctf/contracts/levels/CrosslinkShip.sol",
	"ast": {
		"absolutePath": "/Users/billhsu/Desktop/work/github/cypherpunks-ctf/contracts/levels/CrosslinkShip.sol",
		"exportedSymbols": {
			"CrosslinkShip": [
				564
			]
		},
		"id": 565,
		"nodeType": "SourceUnit",
		"nodes": [
			{
				"id": 271,
				"literals": [
					"solidity",
					"^",
					"0.4",
					".24"
				],
				"nodeType": "PragmaDirective",
				"src": "0:24:3"
			},
			{
				"baseContracts": [],
				"contractDependencies": [],
				"contractKind": "contract",
				"documentation": null,
				"fullyImplemented": true,
				"id": 564,
				"linearizedBaseContracts": [
					564
				],
				"name": "CrosslinkShip",
				"nodeType": "ContractDefinition",
				"nodes": [
					{
						"constant": false,
						"id": 274,
						"name": "htcIsHauled",
						"nodeType": "VariableDeclaration",
						"scope": 564,
						"src": "53:31:3",
						"stateVariable": true,
						"storageLocation": "default",
						"typeDescriptions": {
							"typeIdentifier": "t_bool",
							"typeString": "bool"
						},
						"typeName": {
							"id": 272,
							"name": "bool",
							"nodeType": "ElementaryTypeName",
							"src": "53:4:3",
							"typeDescriptions": {
								"typeIdentifier": "t_bool",
								"typeString": "bool"
							}
						},
						"value": {
							"argumentTypes": null,
							"hexValue": "66616c7365",
							"id": 273,
							"isConstant": false,
							"isLValue": false,
							"isPure": true,
							"kind": "bool",
							"lValueRequested": false,
							"nodeType": "Literal",
							"src": "79:5:3",
							"subdenomination": null,
							"typeDescriptions": {
								"typeIdentifier": "t_bool",
								"typeString": "bool"
							},
							"value": "false"
						},
						"visibility": "public"
					},
					{
						"constant": false,
						"id": 277,
						"name": "anchor",
						"nodeType": "VariableDeclaration",
						"scope": 564,
						"src": "88:27:3",
						"stateVariable": true,
						"storageLocation": "default",
						"typeDescriptions": {
							"typeIdentifier": "t_address",
							"typeString": "address"
						},
						"typeName": {
							"id": 275,
							"name": "address",
							"nodeType": "ElementaryTypeName",
							"src": "88:7:3",
							"typeDescriptions": {
								"typeIdentifier": "t_address",
								"typeString": "address"
							}
						},
						"value": {
							"argumentTypes": null,
							"hexValue": "307830",
							"id": 276,
							"isConstant": false,
							"isLValue": false,
							"isPure": true,
							"kind": "number",
							"lValueRequested": false,
							"nodeType": "Literal",
							"src": "112:3:3",
							"subdenomination": null,
							"typeDescriptions": {
								"typeIdentifier": "t_rational_0_by_1",
								"typeString": "int_const 0"
							},
							"value": "0x0"
						},
						"visibility": "public"
					},
					{
						"body": {
							"id": 307,
							"nodeType": "Block",
							"src": "147:229:3",
							"statements": [
								{
									"expression": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"commonType": {
													"typeIdentifier": "t_address",
													"typeString": "address"
												},
												"id": 283,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"leftExpression": {
													"argumentTypes": null,
													"id": 281,
													"name": "anchor",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 277,
													"src": "161:6:3",
													"typeDescriptions": {
														"typeIdentifier": "t_address",
														"typeString": "address"
													}
												},
												"nodeType": "BinaryOperation",
												"operator": "!=",
												"rightExpression": {
													"argumentTypes": null,
													"hexValue": "307830",
													"id": 282,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "171:3:3",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_0_by_1",
														"typeString": "int_const 0"
													},
													"value": "0x0"
												},
												"src": "161:13:3",
												"typeDescriptions": {
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											],
											"id": 280,
											"name": "require",
											"nodeType": "Identifier",
											"overloadedDeclarations": [
												2940,
												2941
											],
											"referencedDeclaration": 2940,
											"src": "153:7:3",
											"typeDescriptions": {
												"typeIdentifier": "t_function_require_pure$_t_bool_$returns$__$",
												"typeString": "function (bool) pure"
											}
										},
										"id": 284,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "153:22:3",
										"typeDescriptions": {
											"typeIdentifier": "t_tuple$__$",
											"typeString": "tuple()"
										}
									},
									"id": 285,
									"nodeType": "ExpressionStatement",
									"src": "153:22:3"
								},
								{
									"assignments": [
										287
									],
									"declarations": [
										{
											"constant": false,
											"id": 287,
											"name": "size",
											"nodeType": "VariableDeclaration",
											"scope": 308,
											"src": "182:12:3",
											"stateVariable": false,
											"storageLocation": "default",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											},
											"typeName": {
												"id": 286,
												"name": "uint256",
												"nodeType": "ElementaryTypeName",
												"src": "182:7:3",
												"typeDescriptions": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												}
											},
											"value": null,
											"visibility": "internal"
										}
									],
									"id": 289,
									"initialValue": {
										"argumentTypes": null,
										"hexValue": "30",
										"id": 288,
										"isConstant": false,
										"isLValue": false,
										"isPure": true,
										"kind": "number",
										"lValueRequested": false,
										"nodeType": "Literal",
										"src": "197:1:3",
										"subdenomination": null,
										"typeDescriptions": {
											"typeIdentifier": "t_rational_0_by_1",
											"typeString": "int_const 0"
										},
										"value": "0"
									},
									"nodeType": "VariableDeclarationStatement",
									"src": "182:16:3"
								},
								{
									"assignments": [
										291
									],
									"declarations": [
										{
											"constant": false,
											"id": 291,
											"name": "a",
											"nodeType": "VariableDeclaration",
											"scope": 308,
											"src": "204:9:3",
											"stateVariable": false,
											"storageLocation": "default",
											"typeDescriptions": {
												"typeIdentifier": "t_address",
												"typeString": "address"
											},
											"typeName": {
												"id": 290,
												"name": "address",
												"nodeType": "ElementaryTypeName",
												"src": "204:7:3",
												"typeDescriptions": {
													"typeIdentifier": "t_address",
													"typeString": "address"
												}
											},
											"value": null,
											"visibility": "internal"
										}
									],
									"id": 293,
									"initialValue": {
										"argumentTypes": null,
										"id": 292,
										"name": "anchor",
										"nodeType": "Identifier",
										"overloadedDeclarations": [],
										"referencedDeclaration": 277,
										"src": "216:6:3",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"nodeType": "VariableDeclarationStatement",
									"src": "204:18:3"
								},
								{
									"externalReferences": [
										{
											"size": {
												"declaration": 287,
												"isOffset": false,
												"isSlot": false,
												"src": "245:4:3",
												"valueSize": 1
											}
										},
										{
											"a": {
												"declaration": 291,
												"isOffset": false,
												"isSlot": false,
												"src": "265:1:3",
												"valueSize": 1
											}
										}
									],
									"id": 294,
									"nodeType": "InlineAssembly",
									"operations": "{\n    size := extcodesize(a)\n}",
									"src": "228:52:3"
								},
								{
									"condition": {
										"argumentTypes": null,
										"commonType": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										},
										"id": 297,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftExpression": {
											"argumentTypes": null,
											"id": 295,
											"name": "size",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 287,
											"src": "282:4:3",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"nodeType": "BinaryOperation",
										"operator": ">",
										"rightExpression": {
											"argumentTypes": null,
											"hexValue": "30",
											"id": 296,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "number",
											"lValueRequested": false,
											"nodeType": "Literal",
											"src": "289:1:3",
											"subdenomination": null,
											"typeDescriptions": {
												"typeIdentifier": "t_rational_0_by_1",
												"typeString": "int_const 0"
											},
											"value": "0"
										},
										"src": "282:8:3",
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										}
									},
									"falseBody": null,
									"id": 302,
									"nodeType": "IfStatement",
									"src": "278:69:3",
									"trueBody": {
										"id": 301,
										"nodeType": "Block",
										"src": "292:55:3",
										"statements": [
											{
												"expression": {
													"argumentTypes": null,
													"arguments": [],
													"expression": {
														"argumentTypes": [],
														"id": 298,
														"name": "revert",
														"nodeType": "Identifier",
														"overloadedDeclarations": [
															2942,
															2943
														],
														"referencedDeclaration": 2942,
														"src": "300:6:3",
														"typeDescriptions": {
															"typeIdentifier": "t_function_revert_pure$__$returns$__$",
															"typeString": "function () pure"
														}
													},
													"id": 299,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"kind": "functionCall",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "300:8:3",
													"typeDescriptions": {
														"typeIdentifier": "t_tuple$__$",
														"typeString": "tuple()"
													}
												},
												"id": 300,
												"nodeType": "ExpressionStatement",
												"src": "300:8:3"
											}
										]
									}
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 305,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"id": 303,
											"name": "htcIsHauled",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 274,
											"src": "353:11:3",
											"typeDescriptions": {
												"typeIdentifier": "t_bool",
												"typeString": "bool"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"hexValue": "74727565",
											"id": 304,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "bool",
											"lValueRequested": false,
											"nodeType": "Literal",
											"src": "367:4:3",
											"subdenomination": null,
											"typeDescriptions": {
												"typeIdentifier": "t_bool",
												"typeString": "bool"
											},
											"value": "true"
										},
										"src": "353:18:3",
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										}
									},
									"id": 306,
									"nodeType": "ExpressionStatement",
									"src": "353:18:3"
								}
							]
						},
						"documentation": null,
						"id": 308,
						"implemented": true,
						"isConstructor": false,
						"isDeclaredConst": false,
						"modifiers": [],
						"name": "sailAway",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 278,
							"nodeType": "ParameterList",
							"parameters": [],
							"src": "137:2:3"
						},
						"payable": false,
						"returnParameters": {
							"id": 279,
							"nodeType": "ParameterList",
							"parameters": [],
							"src": "147:0:3"
						},
						"scope": 564,
						"src": "120:256:3",
						"stateMutability": "nonpayable",
						"superFunction": null,
						"visibility": "public"
					},
					{
						"body": {
							"id": 322,
							"nodeType": "Block",
							"src": "409:121:3",
							"statements": [
								{
									"condition": {
										"argumentTypes": null,
										"commonType": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										},
										"id": 313,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftExpression": {
											"argumentTypes": null,
											"id": 311,
											"name": "anchor",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 277,
											"src": "419:6:3",
											"typeDescriptions": {
												"typeIdentifier": "t_address",
												"typeString": "address"
											}
										},
										"nodeType": "BinaryOperation",
										"operator": "!=",
										"rightExpression": {
											"argumentTypes": null,
											"hexValue": "30783030",
											"id": 312,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "number",
											"lValueRequested": false,
											"nodeType": "Literal",
											"src": "429:4:3",
											"subdenomination": null,
											"typeDescriptions": {
												"typeIdentifier": "t_rational_0_by_1",
												"typeString": "int_const 0"
											},
											"value": "0x00"
										},
										"src": "419:14:3",
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										}
									},
									"falseBody": null,
									"id": 321,
									"nodeType": "IfStatement",
									"src": "415:111:3",
									"trueBody": {
										"id": 320,
										"nodeType": "Block",
										"src": "435:91:3",
										"statements": [
											{
												"expression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"arguments": [],
															"expression": {
																"argumentTypes": [],
																"expression": {
																	"argumentTypes": null,
																	"id": 315,
																	"name": "anchor",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 277,
																	"src": "451:6:3",
																	"typeDescriptions": {
																		"typeIdentifier": "t_address",
																		"typeString": "address"
																	}
																},
																"id": 316,
																"isConstant": false,
																"isLValue": false,
																"isPure": false,
																"lValueRequested": false,
																"memberName": "call",
																"nodeType": "MemberAccess",
																"referencedDeclaration": null,
																"src": "451:11:3",
																"typeDescriptions": {
																	"typeIdentifier": "t_function_barecall_payable$__$returns$_t_bool_$",
																	"typeString": "function () payable returns (bool)"
																}
															},
															"id": 317,
															"isConstant": false,
															"isLValue": false,
															"isPure": false,
															"kind": "functionCall",
															"lValueRequested": false,
															"names": [],
															"nodeType": "FunctionCall",
															"src": "451:13:3",
															"typeDescriptions": {
																"typeIdentifier": "t_bool",
																"typeString": "bool"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_bool",
																"typeString": "bool"
															}
														],
														"id": 314,
														"name": "require",
														"nodeType": "Identifier",
														"overloadedDeclarations": [
															2940,
															2941
														],
														"referencedDeclaration": 2940,
														"src": "443:7:3",
														"typeDescriptions": {
															"typeIdentifier": "t_function_require_pure$_t_bool_$returns$__$",
															"typeString": "function (bool) pure"
														}
													},
													"id": 318,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"kind": "functionCall",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "443:22:3",
													"typeDescriptions": {
														"typeIdentifier": "t_tuple$__$",
														"typeString": "tuple()"
													}
												},
												"id": 319,
												"nodeType": "ExpressionStatement",
												"src": "443:22:3"
											}
										]
									}
								}
							]
						},
						"documentation": null,
						"id": 323,
						"implemented": true,
						"isConstructor": false,
						"isDeclaredConst": false,
						"modifiers": [],
						"name": "pullAnchor",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 309,
							"nodeType": "ParameterList",
							"parameters": [],
							"src": "399:2:3"
						},
						"payable": false,
						"returnParameters": {
							"id": 310,
							"nodeType": "ParameterList",
							"parameters": [],
							"src": "409:0:3"
						},
						"scope": 564,
						"src": "380:150:3",
						"stateMutability": "nonpayable",
						"superFunction": null,
						"visibility": "public"
					},
					{
						"body": {
							"id": 482,
							"nodeType": "Block",
							"src": "609:925:3",
							"statements": [
								{
									"expression": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"commonType": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												},
												"id": 336,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"leftExpression": {
													"argumentTypes": null,
													"id": 331,
													"name": "blockNumber",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 325,
													"src": "684:11:3",
													"typeDescriptions": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												},
												"nodeType": "BinaryOperation",
												"operator": ">",
												"rightExpression": {
													"argumentTypes": null,
													"commonType": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													},
													"id": 335,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"leftExpression": {
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 332,
															"name": "block",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 2927,
															"src": "698:5:3",
															"typeDescriptions": {
																"typeIdentifier": "t_magic_block",
																"typeString": "block"
															}
														},
														"id": 333,
														"isConstant": false,
														"isLValue": false,
														"isPure": false,
														"lValueRequested": false,
														"memberName": "number",
														"nodeType": "MemberAccess",
														"referencedDeclaration": null,
														"src": "698:12:3",
														"typeDescriptions": {
															"typeIdentifier": "t_uint256",
															"typeString": "uint256"
														}
													},
													"nodeType": "BinaryOperation",
													"operator": "+",
													"rightExpression": {
														"argumentTypes": null,
														"hexValue": "3530303030",
														"id": 334,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "number",
														"lValueRequested": false,
														"nodeType": "Literal",
														"src": "713:5:3",
														"subdenomination": null,
														"typeDescriptions": {
															"typeIdentifier": "t_rational_50000_by_1",
															"typeString": "int_const 50000"
														},
														"value": "50000"
													},
													"src": "698:20:3",
													"typeDescriptions": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												},
												"src": "684:34:3",
												"typeDescriptions": {
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											],
											"id": 330,
											"name": "require",
											"nodeType": "Identifier",
											"overloadedDeclarations": [
												2940,
												2941
											],
											"referencedDeclaration": 2940,
											"src": "676:7:3",
											"typeDescriptions": {
												"typeIdentifier": "t_function_require_pure$_t_bool_$returns$__$",
												"typeString": "function (bool) pure"
											}
										},
										"id": 337,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "676:43:3",
										"typeDescriptions": {
											"typeIdentifier": "t_tuple$__$",
											"typeString": "tuple()"
										}
									},
									"id": 338,
									"nodeType": "ExpressionStatement",
									"src": "676:43:3"
								},
								{
									"assignments": [],
									"declarations": [
										{
											"constant": false,
											"id": 343,
											"name": "a",
											"nodeType": "VariableDeclaration",
											"scope": 483,
											"src": "803:19:3",
											"stateVariable": false,
											"storageLocation": "memory",
											"typeDescriptions": {
												"typeIdentifier": "t_array$_t_uint256_$8_memory_ptr",
												"typeString": "uint256[8]"
											},
											"typeName": {
												"baseType": {
													"id": 341,
													"name": "uint256",
													"nodeType": "ElementaryTypeName",
													"src": "803:7:3",
													"typeDescriptions": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												},
												"id": 342,
												"length": {
													"argumentTypes": null,
													"hexValue": "38",
													"id": 340,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "811:1:3",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": null,
														"typeString": null
													},
													"value": "8"
												},
												"nodeType": "ArrayTypeName",
												"src": "803:10:3",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint256_$8_storage_ptr",
													"typeString": "uint256[8]"
												}
											},
											"value": null,
											"visibility": "internal"
										}
									],
									"id": 344,
									"initialValue": null,
									"nodeType": "VariableDeclarationStatement",
									"src": "803:19:3"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 349,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"id": 345,
												"name": "a",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 343,
												"src": "828:1:3",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint256_$8_memory_ptr",
													"typeString": "uint256[8] memory"
												}
											},
											"id": 347,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "30",
												"id": 346,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "830:1:3",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_0_by_1",
													"typeString": "int_const 0"
												},
												"value": "0"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "828:4:3",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"hexValue": "307836333030",
											"id": 348,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "number",
											"lValueRequested": false,
											"nodeType": "Literal",
											"src": "835:6:3",
											"subdenomination": null,
											"typeDescriptions": {
												"typeIdentifier": "t_rational_25344_by_1",
												"typeString": "int_const 25344"
											},
											"value": "0x6300"
										},
										"src": "828:13:3",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									},
									"id": 350,
									"nodeType": "ExpressionStatement",
									"src": "828:13:3"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 355,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"id": 351,
												"name": "a",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 343,
												"src": "847:1:3",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint256_$8_memory_ptr",
													"typeString": "uint256[8] memory"
												}
											},
											"id": 353,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "31",
												"id": 352,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "849:1:3",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_1_by_1",
													"typeString": "int_const 1"
												},
												"value": "1"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "847:4:3",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"id": 354,
											"name": "blockNumber",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 325,
											"src": "854:11:3",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"src": "847:18:3",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									},
									"id": 356,
									"nodeType": "ExpressionStatement",
									"src": "847:18:3"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 361,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"id": 357,
												"name": "a",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 343,
												"src": "871:1:3",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint256_$8_memory_ptr",
													"typeString": "uint256[8] memory"
												}
											},
											"id": 359,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "32",
												"id": 358,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "873:1:3",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_2_by_1",
													"typeString": "int_const 2"
												},
												"value": "2"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "871:4:3",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"hexValue": "30783433",
											"id": 360,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "number",
											"lValueRequested": false,
											"nodeType": "Literal",
											"src": "878:4:3",
											"subdenomination": null,
											"typeDescriptions": {
												"typeIdentifier": "t_rational_67_by_1",
												"typeString": "int_const 67"
											},
											"value": "0x43"
										},
										"src": "871:11:3",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									},
									"id": 362,
									"nodeType": "ExpressionStatement",
									"src": "871:11:3"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 367,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"id": 363,
												"name": "a",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 343,
												"src": "888:1:3",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint256_$8_memory_ptr",
													"typeString": "uint256[8] memory"
												}
											},
											"id": 365,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "33",
												"id": 364,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "890:1:3",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_3_by_1",
													"typeString": "int_const 3"
												},
												"value": "3"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "888:4:3",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"hexValue": "30783130",
											"id": 366,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "number",
											"lValueRequested": false,
											"nodeType": "Literal",
											"src": "895:4:3",
											"subdenomination": null,
											"typeDescriptions": {
												"typeIdentifier": "t_rational_16_by_1",
												"typeString": "int_const 16"
											},
											"value": "0x10"
										},
										"src": "888:11:3",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									},
									"id": 368,
									"nodeType": "ExpressionStatement",
									"src": "888:11:3"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 373,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"id": 369,
												"name": "a",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 343,
												"src": "905:1:3",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint256_$8_memory_ptr",
													"typeString": "uint256[8] memory"
												}
											},
											"id": 371,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "34",
												"id": 370,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "907:1:3",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_4_by_1",
													"typeString": "int_const 4"
												},
												"value": "4"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "905:4:3",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"hexValue": "30783538",
											"id": 372,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "number",
											"lValueRequested": false,
											"nodeType": "Literal",
											"src": "912:4:3",
											"subdenomination": null,
											"typeDescriptions": {
												"typeIdentifier": "t_rational_88_by_1",
												"typeString": "int_const 88"
											},
											"value": "0x58"
										},
										"src": "905:11:3",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									},
									"id": 374,
									"nodeType": "ExpressionStatement",
									"src": "905:11:3"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 379,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"id": 375,
												"name": "a",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 343,
												"src": "922:1:3",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint256_$8_memory_ptr",
													"typeString": "uint256[8] memory"
												}
											},
											"id": 377,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "35",
												"id": 376,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "924:1:3",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_5_by_1",
													"typeString": "int_const 5"
												},
												"value": "5"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "922:4:3",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"hexValue": "30783537",
											"id": 378,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "number",
											"lValueRequested": false,
											"nodeType": "Literal",
											"src": "929:4:3",
											"subdenomination": null,
											"typeDescriptions": {
												"typeIdentifier": "t_rational_87_by_1",
												"typeString": "int_const 87"
											},
											"value": "0x57"
										},
										"src": "922:11:3",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									},
									"id": 380,
									"nodeType": "ExpressionStatement",
									"src": "922:11:3"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 385,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"id": 381,
												"name": "a",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 343,
												"src": "939:1:3",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint256_$8_memory_ptr",
													"typeString": "uint256[8] memory"
												}
											},
											"id": 383,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "36",
												"id": 382,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "941:1:3",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_6_by_1",
													"typeString": "int_const 6"
												},
												"value": "6"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "939:4:3",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"hexValue": "30783333",
											"id": 384,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "number",
											"lValueRequested": false,
											"nodeType": "Literal",
											"src": "946:4:3",
											"subdenomination": null,
											"typeDescriptions": {
												"typeIdentifier": "t_rational_51_by_1",
												"typeString": "int_const 51"
											},
											"value": "0x33"
										},
										"src": "939:11:3",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									},
									"id": 386,
									"nodeType": "ExpressionStatement",
									"src": "939:11:3"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 391,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"id": 387,
												"name": "a",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 343,
												"src": "956:1:3",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint256_$8_memory_ptr",
													"typeString": "uint256[8] memory"
												}
											},
											"id": 389,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "37",
												"id": 388,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "958:1:3",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_7_by_1",
													"typeString": "int_const 7"
												},
												"value": "7"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "956:4:3",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"hexValue": "30786666",
											"id": 390,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "number",
											"lValueRequested": false,
											"nodeType": "Literal",
											"src": "963:4:3",
											"subdenomination": null,
											"typeDescriptions": {
												"typeIdentifier": "t_rational_255_by_1",
												"typeString": "int_const 255"
											},
											"value": "0xff"
										},
										"src": "956:11:3",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									},
									"id": 392,
									"nodeType": "ExpressionStatement",
									"src": "956:11:3"
								},
								{
									"assignments": [
										394
									],
									"declarations": [
										{
											"constant": false,
											"id": 394,
											"name": "code",
											"nodeType": "VariableDeclaration",
											"scope": 483,
											"src": "974:12:3",
											"stateVariable": false,
											"storageLocation": "default",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											},
											"typeName": {
												"id": 393,
												"name": "uint256",
												"nodeType": "ElementaryTypeName",
												"src": "974:7:3",
												"typeDescriptions": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												}
											},
											"value": null,
											"visibility": "internal"
										}
									],
									"id": 398,
									"initialValue": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"id": 396,
												"name": "a",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 343,
												"src": "998:1:3",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint256_$8_memory_ptr",
													"typeString": "uint256[8] memory"
												}
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_array$_t_uint256_$8_memory_ptr",
													"typeString": "uint256[8] memory"
												}
											],
											"id": 395,
											"name": "assemble",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 521,
											"src": "989:8:3",
											"typeDescriptions": {
												"typeIdentifier": "t_function_internal_pure$_t_array$_t_uint256_$8_memory_ptr_$returns$_t_uint256_$",
												"typeString": "function (uint256[8] memory) pure returns (uint256)"
											}
										},
										"id": 397,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "989:11:3",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									},
									"nodeType": "VariableDeclarationStatement",
									"src": "974:26:3"
								},
								{
									"assignments": [],
									"declarations": [
										{
											"constant": false,
											"id": 403,
											"name": "b",
											"nodeType": "VariableDeclaration",
											"scope": 483,
											"src": "1043:19:3",
											"stateVariable": false,
											"storageLocation": "memory",
											"typeDescriptions": {
												"typeIdentifier": "t_array$_t_uint256_$8_memory_ptr",
												"typeString": "uint256[8]"
											},
											"typeName": {
												"baseType": {
													"id": 401,
													"name": "uint256",
													"nodeType": "ElementaryTypeName",
													"src": "1043:7:3",
													"typeDescriptions": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												},
												"id": 402,
												"length": {
													"argumentTypes": null,
													"hexValue": "38",
													"id": 400,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "1051:1:3",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": null,
														"typeString": null
													},
													"value": "8"
												},
												"nodeType": "ArrayTypeName",
												"src": "1043:10:3",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint256_$8_storage_ptr",
													"typeString": "uint256[8]"
												}
											},
											"value": null,
											"visibility": "internal"
										}
									],
									"id": 404,
									"initialValue": null,
									"nodeType": "VariableDeclarationStatement",
									"src": "1043:19:3"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 409,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"id": 405,
												"name": "b",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 403,
												"src": "1068:1:3",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint256_$8_memory_ptr",
													"typeString": "uint256[8] memory"
												}
											},
											"id": 407,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "30",
												"id": 406,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "1070:1:3",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_0_by_1",
													"typeString": "int_const 0"
												},
												"value": "0"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "1068:4:3",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"hexValue": "30",
											"id": 408,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "number",
											"lValueRequested": false,
											"nodeType": "Literal",
											"src": "1075:1:3",
											"subdenomination": null,
											"typeDescriptions": {
												"typeIdentifier": "t_rational_0_by_1",
												"typeString": "int_const 0"
											},
											"value": "0"
										},
										"src": "1068:8:3",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									},
									"id": 410,
									"nodeType": "ExpressionStatement",
									"src": "1068:8:3"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 415,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"id": 411,
												"name": "b",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 403,
												"src": "1082:1:3",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint256_$8_memory_ptr",
													"typeString": "uint256[8] memory"
												}
											},
											"id": 413,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "31",
												"id": 412,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "1084:1:3",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_1_by_1",
													"typeString": "int_const 1"
												},
												"value": "1"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "1082:4:3",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"hexValue": "30783661",
											"id": 414,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "number",
											"lValueRequested": false,
											"nodeType": "Literal",
											"src": "1089:4:3",
											"subdenomination": null,
											"typeDescriptions": {
												"typeIdentifier": "t_rational_106_by_1",
												"typeString": "int_const 106"
											},
											"value": "0x6a"
										},
										"src": "1082:11:3",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									},
									"id": 416,
									"nodeType": "ExpressionStatement",
									"src": "1082:11:3"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 421,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"id": 417,
												"name": "b",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 403,
												"src": "1099:1:3",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint256_$8_memory_ptr",
													"typeString": "uint256[8] memory"
												}
											},
											"id": 419,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "32",
												"id": 418,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "1101:1:3",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_2_by_1",
													"typeString": "int_const 2"
												},
												"value": "2"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "1099:4:3",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"id": 420,
											"name": "code",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 394,
											"src": "1106:4:3",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"src": "1099:11:3",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									},
									"id": 422,
									"nodeType": "ExpressionStatement",
									"src": "1099:11:3"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 427,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"id": 423,
												"name": "b",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 403,
												"src": "1116:1:3",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint256_$8_memory_ptr",
													"typeString": "uint256[8] memory"
												}
											},
											"id": 425,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "33",
												"id": 424,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "1118:1:3",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_3_by_1",
													"typeString": "int_const 3"
												},
												"value": "3"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "1116:4:3",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"hexValue": "307836303030",
											"id": 426,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "number",
											"lValueRequested": false,
											"nodeType": "Literal",
											"src": "1123:6:3",
											"subdenomination": null,
											"typeDescriptions": {
												"typeIdentifier": "t_rational_24576_by_1",
												"typeString": "int_const 24576"
											},
											"value": "0x6000"
										},
										"src": "1116:13:3",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									},
									"id": 428,
									"nodeType": "ExpressionStatement",
									"src": "1116:13:3"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 433,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"id": 429,
												"name": "b",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 403,
												"src": "1135:1:3",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint256_$8_memory_ptr",
													"typeString": "uint256[8] memory"
												}
											},
											"id": 431,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "34",
												"id": 430,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "1137:1:3",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_4_by_1",
													"typeString": "int_const 4"
												},
												"value": "4"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "1135:4:3",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"hexValue": "30783532",
											"id": 432,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "number",
											"lValueRequested": false,
											"nodeType": "Literal",
											"src": "1142:4:3",
											"subdenomination": null,
											"typeDescriptions": {
												"typeIdentifier": "t_rational_82_by_1",
												"typeString": "int_const 82"
											},
											"value": "0x52"
										},
										"src": "1135:11:3",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									},
									"id": 434,
									"nodeType": "ExpressionStatement",
									"src": "1135:11:3"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 439,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"id": 435,
												"name": "b",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 403,
												"src": "1152:1:3",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint256_$8_memory_ptr",
													"typeString": "uint256[8] memory"
												}
											},
											"id": 437,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "35",
												"id": 436,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "1154:1:3",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_5_by_1",
													"typeString": "int_const 5"
												},
												"value": "5"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "1152:4:3",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"hexValue": "307836303062",
											"id": 438,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "number",
											"lValueRequested": false,
											"nodeType": "Literal",
											"src": "1159:6:3",
											"subdenomination": null,
											"typeDescriptions": {
												"typeIdentifier": "t_rational_24587_by_1",
												"typeString": "int_const 24587"
											},
											"value": "0x600b"
										},
										"src": "1152:13:3",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									},
									"id": 440,
									"nodeType": "ExpressionStatement",
									"src": "1152:13:3"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 445,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"id": 441,
												"name": "b",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 403,
												"src": "1171:1:3",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint256_$8_memory_ptr",
													"typeString": "uint256[8] memory"
												}
											},
											"id": 443,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "36",
												"id": 442,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "1173:1:3",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_6_by_1",
													"typeString": "int_const 6"
												},
												"value": "6"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "1171:4:3",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"hexValue": "307836303135",
											"id": 444,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "number",
											"lValueRequested": false,
											"nodeType": "Literal",
											"src": "1178:6:3",
											"subdenomination": null,
											"typeDescriptions": {
												"typeIdentifier": "t_rational_24597_by_1",
												"typeString": "int_const 24597"
											},
											"value": "0x6015"
										},
										"src": "1171:13:3",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									},
									"id": 446,
									"nodeType": "ExpressionStatement",
									"src": "1171:13:3"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 451,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"id": 447,
												"name": "b",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 403,
												"src": "1190:1:3",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint256_$8_memory_ptr",
													"typeString": "uint256[8] memory"
												}
											},
											"id": 449,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "37",
												"id": 448,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "1192:1:3",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_7_by_1",
													"typeString": "int_const 7"
												},
												"value": "7"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "1190:4:3",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"hexValue": "30786633",
											"id": 450,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "number",
											"lValueRequested": false,
											"nodeType": "Literal",
											"src": "1197:4:3",
											"subdenomination": null,
											"typeDescriptions": {
												"typeIdentifier": "t_rational_243_by_1",
												"typeString": "int_const 243"
											},
											"value": "0xf3"
										},
										"src": "1190:11:3",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									},
									"id": 452,
									"nodeType": "ExpressionStatement",
									"src": "1190:11:3"
								},
								{
									"assignments": [
										454
									],
									"declarations": [
										{
											"constant": false,
											"id": 454,
											"name": "initcode",
											"nodeType": "VariableDeclaration",
											"scope": 483,
											"src": "1208:16:3",
											"stateVariable": false,
											"storageLocation": "default",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											},
											"typeName": {
												"id": 453,
												"name": "uint256",
												"nodeType": "ElementaryTypeName",
												"src": "1208:7:3",
												"typeDescriptions": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												}
											},
											"value": null,
											"visibility": "internal"
										}
									],
									"id": 458,
									"initialValue": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"id": 456,
												"name": "b",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 403,
												"src": "1236:1:3",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint256_$8_memory_ptr",
													"typeString": "uint256[8] memory"
												}
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_array$_t_uint256_$8_memory_ptr",
													"typeString": "uint256[8] memory"
												}
											],
											"id": 455,
											"name": "assemble",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 521,
											"src": "1227:8:3",
											"typeDescriptions": {
												"typeIdentifier": "t_function_internal_pure$_t_array$_t_uint256_$8_memory_ptr_$returns$_t_uint256_$",
												"typeString": "function (uint256[8] memory) pure returns (uint256)"
											}
										},
										"id": 457,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "1227:11:3",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									},
									"nodeType": "VariableDeclarationStatement",
									"src": "1208:30:3"
								},
								{
									"assignments": [
										460
									],
									"declarations": [
										{
											"constant": false,
											"id": 460,
											"name": "sz",
											"nodeType": "VariableDeclaration",
											"scope": 483,
											"src": "1244:10:3",
											"stateVariable": false,
											"storageLocation": "default",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											},
											"typeName": {
												"id": 459,
												"name": "uint256",
												"nodeType": "ElementaryTypeName",
												"src": "1244:7:3",
												"typeDescriptions": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												}
											},
											"value": null,
											"visibility": "internal"
										}
									],
									"id": 464,
									"initialValue": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"id": 462,
												"name": "initcode",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 454,
												"src": "1265:8:3",
												"typeDescriptions": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												}
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												}
											],
											"id": 461,
											"name": "getSize",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 563,
											"src": "1257:7:3",
											"typeDescriptions": {
												"typeIdentifier": "t_function_internal_pure$_t_uint256_$returns$_t_uint256_$",
												"typeString": "function (uint256) pure returns (uint256)"
											}
										},
										"id": 463,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "1257:17:3",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									},
									"nodeType": "VariableDeclarationStatement",
									"src": "1244:30:3"
								},
								{
									"assignments": [
										466
									],
									"declarations": [
										{
											"constant": false,
											"id": 466,
											"name": "offset",
											"nodeType": "VariableDeclaration",
											"scope": 483,
											"src": "1280:14:3",
											"stateVariable": false,
											"storageLocation": "default",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											},
											"typeName": {
												"id": 465,
												"name": "uint256",
												"nodeType": "ElementaryTypeName",
												"src": "1280:7:3",
												"typeDescriptions": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												}
											},
											"value": null,
											"visibility": "internal"
										}
									],
									"id": 470,
									"initialValue": {
										"argumentTypes": null,
										"commonType": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										},
										"id": 469,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftExpression": {
											"argumentTypes": null,
											"hexValue": "3332",
											"id": 467,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "number",
											"lValueRequested": false,
											"nodeType": "Literal",
											"src": "1297:2:3",
											"subdenomination": null,
											"typeDescriptions": {
												"typeIdentifier": "t_rational_32_by_1",
												"typeString": "int_const 32"
											},
											"value": "32"
										},
										"nodeType": "BinaryOperation",
										"operator": "-",
										"rightExpression": {
											"argumentTypes": null,
											"id": 468,
											"name": "sz",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 460,
											"src": "1302:2:3",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"src": "1297:7:3",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									},
									"nodeType": "VariableDeclarationStatement",
									"src": "1280:24:3"
								},
								{
									"externalReferences": [
										{
											"initcode": {
												"declaration": 454,
												"isOffset": false,
												"isSlot": false,
												"src": "1405:8:3",
												"valueSize": 1
											}
										},
										{
											"addr": {
												"declaration": 328,
												"isOffset": false,
												"isSlot": false,
												"src": "1421:4:3",
												"valueSize": 1
											}
										},
										{
											"offset": {
												"declaration": 466,
												"isOffset": false,
												"isSlot": false,
												"src": "1466:6:3",
												"valueSize": 1
											}
										},
										{
											"sz": {
												"declaration": 460,
												"isOffset": false,
												"isSlot": false,
												"src": "1475:2:3",
												"valueSize": 1
											}
										}
									],
									"id": 471,
									"nodeType": "InlineAssembly",
									"operations": "{\n    let solidity_free_mem_ptr := mload(0x40)\n    mstore(solidity_free_mem_ptr, initcode)\n    addr := create(0, add(solidity_free_mem_ptr, offset), sz)\n}",
									"src": "1311:186:3"
								},
								{
									"expression": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"commonType": {
													"typeIdentifier": "t_address",
													"typeString": "address"
												},
												"id": 475,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"leftExpression": {
													"argumentTypes": null,
													"id": 473,
													"name": "addr",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 328,
													"src": "1498:4:3",
													"typeDescriptions": {
														"typeIdentifier": "t_address",
														"typeString": "address"
													}
												},
												"nodeType": "BinaryOperation",
												"operator": "!=",
												"rightExpression": {
													"argumentTypes": null,
													"hexValue": "307830",
													"id": 474,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "1506:3:3",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_0_by_1",
														"typeString": "int_const 0"
													},
													"value": "0x0"
												},
												"src": "1498:11:3",
												"typeDescriptions": {
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											],
											"id": 472,
											"name": "require",
											"nodeType": "Identifier",
											"overloadedDeclarations": [
												2940,
												2941
											],
											"referencedDeclaration": 2940,
											"src": "1490:7:3",
											"typeDescriptions": {
												"typeIdentifier": "t_function_require_pure$_t_bool_$returns$__$",
												"typeString": "function (bool) pure"
											}
										},
										"id": 476,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "1490:20:3",
										"typeDescriptions": {
											"typeIdentifier": "t_tuple$__$",
											"typeString": "tuple()"
										}
									},
									"id": 477,
									"nodeType": "ExpressionStatement",
									"src": "1490:20:3"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 480,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"id": 478,
											"name": "anchor",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 277,
											"src": "1516:6:3",
											"typeDescriptions": {
												"typeIdentifier": "t_address",
												"typeString": "address"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"id": 479,
											"name": "addr",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 328,
											"src": "1525:4:3",
											"typeDescriptions": {
												"typeIdentifier": "t_address",
												"typeString": "address"
											}
										},
										"src": "1516:13:3",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"id": 481,
									"nodeType": "ExpressionStatement",
									"src": "1516:13:3"
								}
							]
						},
						"documentation": null,
						"id": 483,
						"implemented": true,
						"isConstructor": false,
						"isDeclaredConst": false,
						"modifiers": [],
						"name": "dropShipAnchor",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 326,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 325,
									"name": "blockNumber",
									"nodeType": "VariableDeclaration",
									"scope": 483,
									"src": "558:19:3",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_uint256",
										"typeString": "uint256"
									},
									"typeName": {
										"id": 324,
										"name": "uint256",
										"nodeType": "ElementaryTypeName",
										"src": "558:7:3",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "557:21:3"
						},
						"payable": false,
						"returnParameters": {
							"id": 329,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 328,
									"name": "addr",
									"nodeType": "VariableDeclaration",
									"scope": 483,
									"src": "595:12:3",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_address",
										"typeString": "address"
									},
									"typeName": {
										"id": 327,
										"name": "address",
										"nodeType": "ElementaryTypeName",
										"src": "595:7:3",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "594:14:3"
						},
						"scope": 564,
						"src": "534:1000:3",
						"stateMutability": "nonpayable",
						"superFunction": null,
						"visibility": "public"
					},
					{
						"body": {
							"id": 520,
							"nodeType": "Block",
							"src": "1659:113:3",
							"statements": [
								{
									"body": {
										"id": 518,
										"nodeType": "Block",
										"src": "1709:59:3",
										"statements": [
											{
												"expression": {
													"argumentTypes": null,
													"id": 516,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"leftHandSide": {
														"argumentTypes": null,
														"id": 503,
														"name": "code",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 490,
														"src": "1717:4:3",
														"typeDescriptions": {
															"typeIdentifier": "t_uint256",
															"typeString": "uint256"
														}
													},
													"nodeType": "Assignment",
													"operator": "^=",
													"rightHandSide": {
														"argumentTypes": null,
														"commonType": {
															"typeIdentifier": "t_uint256",
															"typeString": "uint256"
														},
														"id": 515,
														"isConstant": false,
														"isLValue": false,
														"isPure": false,
														"lValueRequested": false,
														"leftExpression": {
															"argumentTypes": null,
															"baseExpression": {
																"argumentTypes": null,
																"id": 504,
																"name": "chunks",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 487,
																"src": "1725:6:3",
																"typeDescriptions": {
																	"typeIdentifier": "t_array$_t_uint256_$8_memory_ptr",
																	"typeString": "uint256[8] memory"
																}
															},
															"id": 508,
															"indexExpression": {
																"argumentTypes": null,
																"commonType": {
																	"typeIdentifier": "t_uint256",
																	"typeString": "uint256"
																},
																"id": 507,
																"isConstant": false,
																"isLValue": false,
																"isPure": false,
																"lValueRequested": false,
																"leftExpression": {
																	"argumentTypes": null,
																	"id": 505,
																	"name": "i",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 493,
																	"src": "1732:1:3",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint256",
																		"typeString": "uint256"
																	}
																},
																"nodeType": "BinaryOperation",
																"operator": "-",
																"rightExpression": {
																	"argumentTypes": null,
																	"hexValue": "31",
																	"id": 506,
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": true,
																	"kind": "number",
																	"lValueRequested": false,
																	"nodeType": "Literal",
																	"src": "1736:1:3",
																	"subdenomination": null,
																	"typeDescriptions": {
																		"typeIdentifier": "t_rational_1_by_1",
																		"typeString": "int_const 1"
																	},
																	"value": "1"
																},
																"src": "1732:5:3",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint256",
																	"typeString": "uint256"
																}
															},
															"isConstant": false,
															"isLValue": true,
															"isPure": false,
															"lValueRequested": false,
															"nodeType": "IndexAccess",
															"src": "1725:13:3",
															"typeDescriptions": {
																"typeIdentifier": "t_uint256",
																"typeString": "uint256"
															}
														},
														"nodeType": "BinaryOperation",
														"operator": "<<",
														"rightExpression": {
															"argumentTypes": null,
															"components": [
																{
																	"argumentTypes": null,
																	"commonType": {
																		"typeIdentifier": "t_uint256",
																		"typeString": "uint256"
																	},
																	"id": 513,
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": false,
																	"lValueRequested": false,
																	"leftExpression": {
																		"argumentTypes": null,
																		"hexValue": "38",
																		"id": 509,
																		"isConstant": false,
																		"isLValue": false,
																		"isPure": true,
																		"kind": "number",
																		"lValueRequested": false,
																		"nodeType": "Literal",
																		"src": "1743:1:3",
																		"subdenomination": null,
																		"typeDescriptions": {
																			"typeIdentifier": "t_rational_8_by_1",
																			"typeString": "int_const 8"
																		},
																		"value": "8"
																	},
																	"nodeType": "BinaryOperation",
																	"operator": "*",
																	"rightExpression": {
																		"argumentTypes": null,
																		"arguments": [
																			{
																				"argumentTypes": null,
																				"id": 511,
																				"name": "code",
																				"nodeType": "Identifier",
																				"overloadedDeclarations": [],
																				"referencedDeclaration": 490,
																				"src": "1755:4:3",
																				"typeDescriptions": {
																					"typeIdentifier": "t_uint256",
																					"typeString": "uint256"
																				}
																			}
																		],
																		"expression": {
																			"argumentTypes": [
																				{
																					"typeIdentifier": "t_uint256",
																					"typeString": "uint256"
																				}
																			],
																			"id": 510,
																			"name": "getSize",
																			"nodeType": "Identifier",
																			"overloadedDeclarations": [],
																			"referencedDeclaration": 563,
																			"src": "1747:7:3",
																			"typeDescriptions": {
																				"typeIdentifier": "t_function_internal_pure$_t_uint256_$returns$_t_uint256_$",
																				"typeString": "function (uint256) pure returns (uint256)"
																			}
																		},
																		"id": 512,
																		"isConstant": false,
																		"isLValue": false,
																		"isPure": false,
																		"kind": "functionCall",
																		"lValueRequested": false,
																		"names": [],
																		"nodeType": "FunctionCall",
																		"src": "1747:13:3",
																		"typeDescriptions": {
																			"typeIdentifier": "t_uint256",
																			"typeString": "uint256"
																		}
																	},
																	"src": "1743:17:3",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint256",
																		"typeString": "uint256"
																	}
																}
															],
															"id": 514,
															"isConstant": false,
															"isInlineArray": false,
															"isLValue": false,
															"isPure": false,
															"lValueRequested": false,
															"nodeType": "TupleExpression",
															"src": "1742:19:3",
															"typeDescriptions": {
																"typeIdentifier": "t_uint256",
																"typeString": "uint256"
															}
														},
														"src": "1725:36:3",
														"typeDescriptions": {
															"typeIdentifier": "t_uint256",
															"typeString": "uint256"
														}
													},
													"src": "1717:44:3",
													"typeDescriptions": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												},
												"id": 517,
												"nodeType": "ExpressionStatement",
												"src": "1717:44:3"
											}
										]
									},
									"condition": {
										"argumentTypes": null,
										"commonType": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										},
										"id": 499,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftExpression": {
											"argumentTypes": null,
											"id": 497,
											"name": "i",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 493,
											"src": "1697:1:3",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"nodeType": "BinaryOperation",
										"operator": ">",
										"rightExpression": {
											"argumentTypes": null,
											"hexValue": "30",
											"id": 498,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "number",
											"lValueRequested": false,
											"nodeType": "Literal",
											"src": "1701:1:3",
											"subdenomination": null,
											"typeDescriptions": {
												"typeIdentifier": "t_rational_0_by_1",
												"typeString": "int_const 0"
											},
											"value": "0"
										},
										"src": "1697:5:3",
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										}
									},
									"id": 519,
									"initializationExpression": {
										"assignments": [
											493
										],
										"declarations": [
											{
												"constant": false,
												"id": 493,
												"name": "i",
												"nodeType": "VariableDeclaration",
												"scope": 521,
												"src": "1670:9:3",
												"stateVariable": false,
												"storageLocation": "default",
												"typeDescriptions": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												},
												"typeName": {
													"id": 492,
													"name": "uint256",
													"nodeType": "ElementaryTypeName",
													"src": "1670:7:3",
													"typeDescriptions": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												},
												"value": null,
												"visibility": "internal"
											}
										],
										"id": 496,
										"initialValue": {
											"argumentTypes": null,
											"expression": {
												"argumentTypes": null,
												"id": 494,
												"name": "chunks",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 487,
												"src": "1682:6:3",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint256_$8_memory_ptr",
													"typeString": "uint256[8] memory"
												}
											},
											"id": 495,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"memberName": "length",
											"nodeType": "MemberAccess",
											"referencedDeclaration": null,
											"src": "1682:13:3",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"nodeType": "VariableDeclarationStatement",
										"src": "1670:25:3"
									},
									"loopExpression": {
										"expression": {
											"argumentTypes": null,
											"id": 501,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"nodeType": "UnaryOperation",
											"operator": "--",
											"prefix": false,
											"src": "1704:3:3",
											"subExpression": {
												"argumentTypes": null,
												"id": 500,
												"name": "i",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 493,
												"src": "1704:1:3",
												"typeDescriptions": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												}
											},
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"id": 502,
										"nodeType": "ExpressionStatement",
										"src": "1704:3:3"
									},
									"nodeType": "ForStatement",
									"src": "1665:103:3"
								}
							]
						},
						"documentation": "////////////// HELPERS /////////////////",
						"id": 521,
						"implemented": true,
						"isConstructor": false,
						"isDeclaredConst": true,
						"modifiers": [],
						"name": "assemble",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 488,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 487,
									"name": "chunks",
									"nodeType": "VariableDeclaration",
									"scope": 521,
									"src": "1603:17:3",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_array$_t_uint256_$8_memory_ptr",
										"typeString": "uint256[8]"
									},
									"typeName": {
										"baseType": {
											"id": 484,
											"name": "uint256",
											"nodeType": "ElementaryTypeName",
											"src": "1603:7:3",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"id": 486,
										"length": {
											"argumentTypes": null,
											"hexValue": "38",
											"id": 485,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"kind": "number",
											"lValueRequested": false,
											"nodeType": "Literal",
											"src": "1611:1:3",
											"subdenomination": null,
											"typeDescriptions": {
												"typeIdentifier": null,
												"typeString": null
											},
											"value": "8"
										},
										"nodeType": "ArrayTypeName",
										"src": "1603:10:3",
										"typeDescriptions": {
											"typeIdentifier": "t_array$_t_uint256_$8_storage_ptr",
											"typeString": "uint256[8]"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "1602:19:3"
						},
						"payable": false,
						"returnParameters": {
							"id": 491,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 490,
									"name": "code",
									"nodeType": "VariableDeclaration",
									"scope": 521,
									"src": "1645:12:3",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_uint256",
										"typeString": "uint256"
									},
									"typeName": {
										"id": 489,
										"name": "uint256",
										"nodeType": "ElementaryTypeName",
										"src": "1645:7:3",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "1644:14:3"
						},
						"scope": 564,
						"src": "1585:187:3",
						"stateMutability": "pure",
						"superFunction": null,
						"visibility": "internal"
					},
					{
						"body": {
							"id": 562,
							"nodeType": "Block",
							"src": "1840:212:3",
							"statements": [
								{
									"assignments": [
										529
									],
									"declarations": [
										{
											"constant": false,
											"id": 529,
											"name": "b",
											"nodeType": "VariableDeclaration",
											"scope": 563,
											"src": "1846:14:3",
											"stateVariable": false,
											"storageLocation": "memory",
											"typeDescriptions": {
												"typeIdentifier": "t_bytes_memory_ptr",
												"typeString": "bytes"
											},
											"typeName": {
												"id": 528,
												"name": "bytes",
												"nodeType": "ElementaryTypeName",
												"src": "1846:5:3",
												"typeDescriptions": {
													"typeIdentifier": "t_bytes_storage_ptr",
													"typeString": "bytes"
												}
											},
											"value": null,
											"visibility": "internal"
										}
									],
									"id": 534,
									"initialValue": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"hexValue": "3332",
												"id": 532,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "1873:2:3",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_32_by_1",
													"typeString": "int_const 32"
												},
												"value": "32"
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_rational_32_by_1",
													"typeString": "int_const 32"
												}
											],
											"id": 531,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"lValueRequested": false,
											"nodeType": "NewExpression",
											"src": "1863:9:3",
											"typeDescriptions": {
												"typeIdentifier": "t_function_objectcreation_pure$_t_uint256_$returns$_t_bytes_memory_$",
												"typeString": "function (uint256) pure returns (bytes memory)"
											},
											"typeName": {
												"id": 530,
												"name": "bytes",
												"nodeType": "ElementaryTypeName",
												"src": "1867:5:3",
												"typeDescriptions": {
													"typeIdentifier": "t_bytes_storage_ptr",
													"typeString": "bytes"
												}
											}
										},
										"id": 533,
										"isConstant": false,
										"isLValue": false,
										"isPure": true,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "1863:13:3",
										"typeDescriptions": {
											"typeIdentifier": "t_bytes_memory",
											"typeString": "bytes memory"
										}
									},
									"nodeType": "VariableDeclarationStatement",
									"src": "1846:30:3"
								},
								{
									"externalReferences": [
										{
											"chunk": {
												"declaration": 523,
												"isOffset": false,
												"isSlot": false,
												"src": "1918:5:3",
												"valueSize": 1
											}
										},
										{
											"b": {
												"declaration": 529,
												"isOffset": false,
												"isSlot": false,
												"src": "1910:1:3",
												"valueSize": 1
											}
										}
									],
									"id": 535,
									"nodeType": "InlineAssembly",
									"operations": "{\n    mstore(add(b, 32), chunk)\n}",
									"src": "1882:56:3"
								},
								{
									"body": {
										"id": 558,
										"nodeType": "Block",
										"src": "1973:61:3",
										"statements": [
											{
												"condition": {
													"argumentTypes": null,
													"commonType": {
														"typeIdentifier": "t_bytes1",
														"typeString": "bytes1"
													},
													"id": 551,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"leftExpression": {
														"argumentTypes": null,
														"baseExpression": {
															"argumentTypes": null,
															"id": 547,
															"name": "b",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 529,
															"src": "1985:1:3",
															"typeDescriptions": {
																"typeIdentifier": "t_bytes_memory_ptr",
																"typeString": "bytes memory"
															}
														},
														"id": 549,
														"indexExpression": {
															"argumentTypes": null,
															"id": 548,
															"name": "i",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 537,
															"src": "1987:1:3",
															"typeDescriptions": {
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															}
														},
														"isConstant": false,
														"isLValue": true,
														"isPure": false,
														"lValueRequested": false,
														"nodeType": "IndexAccess",
														"src": "1985:4:3",
														"typeDescriptions": {
															"typeIdentifier": "t_bytes1",
															"typeString": "bytes1"
														}
													},
													"nodeType": "BinaryOperation",
													"operator": "!=",
													"rightExpression": {
														"argumentTypes": null,
														"hexValue": "30",
														"id": 550,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "number",
														"lValueRequested": false,
														"nodeType": "Literal",
														"src": "1993:1:3",
														"subdenomination": null,
														"typeDescriptions": {
															"typeIdentifier": "t_rational_0_by_1",
															"typeString": "int_const 0"
														},
														"value": "0"
													},
													"src": "1985:9:3",
													"typeDescriptions": {
														"typeIdentifier": "t_bool",
														"typeString": "bool"
													}
												},
												"falseBody": null,
												"id": 557,
												"nodeType": "IfStatement",
												"src": "1981:47:3",
												"trueBody": {
													"id": 556,
													"nodeType": "Block",
													"src": "1996:32:3",
													"statements": [
														{
															"expression": {
																"argumentTypes": null,
																"commonType": {
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																},
																"id": 554,
																"isConstant": false,
																"isLValue": false,
																"isPure": false,
																"lValueRequested": false,
																"leftExpression": {
																	"argumentTypes": null,
																	"hexValue": "3332",
																	"id": 552,
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": true,
																	"kind": "number",
																	"lValueRequested": false,
																	"nodeType": "Literal",
																	"src": "2013:2:3",
																	"subdenomination": null,
																	"typeDescriptions": {
																		"typeIdentifier": "t_rational_32_by_1",
																		"typeString": "int_const 32"
																	},
																	"value": "32"
																},
																"nodeType": "BinaryOperation",
																"operator": "-",
																"rightExpression": {
																	"argumentTypes": null,
																	"id": 553,
																	"name": "i",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 537,
																	"src": "2018:1:3",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	}
																},
																"src": "2013:6:3",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																}
															},
															"functionReturnParameters": 527,
															"id": 555,
															"nodeType": "Return",
															"src": "2006:13:3"
														}
													]
												}
											}
										]
									},
									"condition": {
										"argumentTypes": null,
										"commonType": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										},
										"id": 543,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftExpression": {
											"argumentTypes": null,
											"id": 540,
											"name": "i",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 537,
											"src": "1954:1:3",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "BinaryOperation",
										"operator": "<",
										"rightExpression": {
											"argumentTypes": null,
											"expression": {
												"argumentTypes": null,
												"id": 541,
												"name": "b",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 529,
												"src": "1958:1:3",
												"typeDescriptions": {
													"typeIdentifier": "t_bytes_memory_ptr",
													"typeString": "bytes memory"
												}
											},
											"id": 542,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"memberName": "length",
											"nodeType": "MemberAccess",
											"referencedDeclaration": null,
											"src": "1958:8:3",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"src": "1954:12:3",
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										}
									},
									"id": 559,
									"initializationExpression": {
										"assignments": [
											537
										],
										"declarations": [
											{
												"constant": false,
												"id": 537,
												"name": "i",
												"nodeType": "VariableDeclaration",
												"scope": 563,
												"src": "1940:8:3",
												"stateVariable": false,
												"storageLocation": "default",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												},
												"typeName": {
													"id": 536,
													"name": "uint32",
													"nodeType": "ElementaryTypeName",
													"src": "1940:6:3",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"value": null,
												"visibility": "internal"
											}
										],
										"id": 539,
										"initialValue": {
											"argumentTypes": null,
											"hexValue": "30",
											"id": 538,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "number",
											"lValueRequested": false,
											"nodeType": "Literal",
											"src": "1951:1:3",
											"subdenomination": null,
											"typeDescriptions": {
												"typeIdentifier": "t_rational_0_by_1",
												"typeString": "int_const 0"
											},
											"value": "0"
										},
										"nodeType": "VariableDeclarationStatement",
										"src": "1940:12:3"
									},
									"loopExpression": {
										"expression": {
											"argumentTypes": null,
											"id": 545,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"nodeType": "UnaryOperation",
											"operator": "++",
											"prefix": false,
											"src": "1968:3:3",
											"subExpression": {
												"argumentTypes": null,
												"id": 544,
												"name": "i",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 537,
												"src": "1968:1:3",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 546,
										"nodeType": "ExpressionStatement",
										"src": "1968:3:3"
									},
									"nodeType": "ForStatement",
									"src": "1935:99:3"
								},
								{
									"expression": {
										"argumentTypes": null,
										"hexValue": "30",
										"id": 560,
										"isConstant": false,
										"isLValue": false,
										"isPure": true,
										"kind": "number",
										"lValueRequested": false,
										"nodeType": "Literal",
										"src": "2046:1:3",
										"subdenomination": null,
										"typeDescriptions": {
											"typeIdentifier": "t_rational_0_by_1",
											"typeString": "int_const 0"
										},
										"value": "0"
									},
									"functionReturnParameters": 527,
									"id": 561,
									"nodeType": "Return",
									"src": "2039:8:3"
								}
							]
						},
						"documentation": null,
						"id": 563,
						"implemented": true,
						"isConstructor": false,
						"isDeclaredConst": true,
						"modifiers": [],
						"name": "getSize",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 524,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 523,
									"name": "chunk",
									"nodeType": "VariableDeclaration",
									"scope": 563,
									"src": "1793:13:3",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_uint256",
										"typeString": "uint256"
									},
									"typeName": {
										"id": 522,
										"name": "uint256",
										"nodeType": "ElementaryTypeName",
										"src": "1793:7:3",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "1792:15:3"
						},
						"payable": false,
						"returnParameters": {
							"id": 527,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 526,
									"name": "",
									"nodeType": "VariableDeclaration",
									"scope": 563,
									"src": "1831:7:3",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_uint256",
										"typeString": "uint256"
									},
									"typeName": {
										"id": 525,
										"name": "uint256",
										"nodeType": "ElementaryTypeName",
										"src": "1831:7:3",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "1830:9:3"
						},
						"scope": 564,
						"src": "1776:276:3",
						"stateMutability": "pure",
						"superFunction": null,
						"visibility": "internal"
					}
				],
				"scope": 565,
				"src": "26:2028:3"
			}
		],
		"src": "0:2055:3"
	},
	"legacyAST": {
		"absolutePath": "/Users/billhsu/Desktop/work/github/cypherpunks-ctf/contracts/levels/CrosslinkShip.sol",
		"exportedSymbols": {
			"CrosslinkShip": [
				564
			]
		},
		"id": 565,
		"nodeType": "SourceUnit",
		"nodes": [
			{
				"id": 271,
				"literals": [
					"solidity",
					"^",
					"0.4",
					".24"
				],
				"nodeType": "PragmaDirective",
				"src": "0:24:3"
			},
			{
				"baseContracts": [],
				"contractDependencies": [],
				"contractKind": "contract",
				"documentation": null,
				"fullyImplemented": true,
				"id": 564,
				"linearizedBaseContracts": [
					564
				],
				"name": "CrosslinkShip",
				"nodeType": "ContractDefinition",
				"nodes": [
					{
						"constant": false,
						"id": 274,
						"name": "htcIsHauled",
						"nodeType": "VariableDeclaration",
						"scope": 564,
						"src": "53:31:3",
						"stateVariable": true,
						"storageLocation": "default",
						"typeDescriptions": {
							"typeIdentifier": "t_bool",
							"typeString": "bool"
						},
						"typeName": {
							"id": 272,
							"name": "bool",
							"nodeType": "ElementaryTypeName",
							"src": "53:4:3",
							"typeDescriptions": {
								"typeIdentifier": "t_bool",
								"typeString": "bool"
							}
						},
						"value": {
							"argumentTypes": null,
							"hexValue": "66616c7365",
							"id": 273,
							"isConstant": false,
							"isLValue": false,
							"isPure": true,
							"kind": "bool",
							"lValueRequested": false,
							"nodeType": "Literal",
							"src": "79:5:3",
							"subdenomination": null,
							"typeDescriptions": {
								"typeIdentifier": "t_bool",
								"typeString": "bool"
							},
							"value": "false"
						},
						"visibility": "public"
					},
					{
						"constant": false,
						"id": 277,
						"name": "anchor",
						"nodeType": "VariableDeclaration",
						"scope": 564,
						"src": "88:27:3",
						"stateVariable": true,
						"storageLocation": "default",
						"typeDescriptions": {
							"typeIdentifier": "t_address",
							"typeString": "address"
						},
						"typeName": {
							"id": 275,
							"name": "address",
							"nodeType": "ElementaryTypeName",
							"src": "88:7:3",
							"typeDescriptions": {
								"typeIdentifier": "t_address",
								"typeString": "address"
							}
						},
						"value": {
							"argumentTypes": null,
							"hexValue": "307830",
							"id": 276,
							"isConstant": false,
							"isLValue": false,
							"isPure": true,
							"kind": "number",
							"lValueRequested": false,
							"nodeType": "Literal",
							"src": "112:3:3",
							"subdenomination": null,
							"typeDescriptions": {
								"typeIdentifier": "t_rational_0_by_1",
								"typeString": "int_const 0"
							},
							"value": "0x0"
						},
						"visibility": "public"
					},
					{
						"body": {
							"id": 307,
							"nodeType": "Block",
							"src": "147:229:3",
							"statements": [
								{
									"expression": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"commonType": {
													"typeIdentifier": "t_address",
													"typeString": "address"
												},
												"id": 283,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"leftExpression": {
													"argumentTypes": null,
													"id": 281,
													"name": "anchor",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 277,
													"src": "161:6:3",
													"typeDescriptions": {
														"typeIdentifier": "t_address",
														"typeString": "address"
													}
												},
												"nodeType": "BinaryOperation",
												"operator": "!=",
												"rightExpression": {
													"argumentTypes": null,
													"hexValue": "307830",
													"id": 282,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "171:3:3",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_0_by_1",
														"typeString": "int_const 0"
													},
													"value": "0x0"
												},
												"src": "161:13:3",
												"typeDescriptions": {
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											],
											"id": 280,
											"name": "require",
											"nodeType": "Identifier",
											"overloadedDeclarations": [
												2940,
												2941
											],
											"referencedDeclaration": 2940,
											"src": "153:7:3",
											"typeDescriptions": {
												"typeIdentifier": "t_function_require_pure$_t_bool_$returns$__$",
												"typeString": "function (bool) pure"
											}
										},
										"id": 284,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "153:22:3",
										"typeDescriptions": {
											"typeIdentifier": "t_tuple$__$",
											"typeString": "tuple()"
										}
									},
									"id": 285,
									"nodeType": "ExpressionStatement",
									"src": "153:22:3"
								},
								{
									"assignments": [
										287
									],
									"declarations": [
										{
											"constant": false,
											"id": 287,
											"name": "size",
											"nodeType": "VariableDeclaration",
											"scope": 308,
											"src": "182:12:3",
											"stateVariable": false,
											"storageLocation": "default",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											},
											"typeName": {
												"id": 286,
												"name": "uint256",
												"nodeType": "ElementaryTypeName",
												"src": "182:7:3",
												"typeDescriptions": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												}
											},
											"value": null,
											"visibility": "internal"
										}
									],
									"id": 289,
									"initialValue": {
										"argumentTypes": null,
										"hexValue": "30",
										"id": 288,
										"isConstant": false,
										"isLValue": false,
										"isPure": true,
										"kind": "number",
										"lValueRequested": false,
										"nodeType": "Literal",
										"src": "197:1:3",
										"subdenomination": null,
										"typeDescriptions": {
											"typeIdentifier": "t_rational_0_by_1",
											"typeString": "int_const 0"
										},
										"value": "0"
									},
									"nodeType": "VariableDeclarationStatement",
									"src": "182:16:3"
								},
								{
									"assignments": [
										291
									],
									"declarations": [
										{
											"constant": false,
											"id": 291,
											"name": "a",
											"nodeType": "VariableDeclaration",
											"scope": 308,
											"src": "204:9:3",
											"stateVariable": false,
											"storageLocation": "default",
											"typeDescriptions": {
												"typeIdentifier": "t_address",
												"typeString": "address"
											},
											"typeName": {
												"id": 290,
												"name": "address",
												"nodeType": "ElementaryTypeName",
												"src": "204:7:3",
												"typeDescriptions": {
													"typeIdentifier": "t_address",
													"typeString": "address"
												}
											},
											"value": null,
											"visibility": "internal"
										}
									],
									"id": 293,
									"initialValue": {
										"argumentTypes": null,
										"id": 292,
										"name": "anchor",
										"nodeType": "Identifier",
										"overloadedDeclarations": [],
										"referencedDeclaration": 277,
										"src": "216:6:3",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"nodeType": "VariableDeclarationStatement",
									"src": "204:18:3"
								},
								{
									"externalReferences": [
										{
											"size": {
												"declaration": 287,
												"isOffset": false,
												"isSlot": false,
												"src": "245:4:3",
												"valueSize": 1
											}
										},
										{
											"a": {
												"declaration": 291,
												"isOffset": false,
												"isSlot": false,
												"src": "265:1:3",
												"valueSize": 1
											}
										}
									],
									"id": 294,
									"nodeType": "InlineAssembly",
									"operations": "{\n    size := extcodesize(a)\n}",
									"src": "228:52:3"
								},
								{
									"condition": {
										"argumentTypes": null,
										"commonType": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										},
										"id": 297,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftExpression": {
											"argumentTypes": null,
											"id": 295,
											"name": "size",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 287,
											"src": "282:4:3",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"nodeType": "BinaryOperation",
										"operator": ">",
										"rightExpression": {
											"argumentTypes": null,
											"hexValue": "30",
											"id": 296,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "number",
											"lValueRequested": false,
											"nodeType": "Literal",
											"src": "289:1:3",
											"subdenomination": null,
											"typeDescriptions": {
												"typeIdentifier": "t_rational_0_by_1",
												"typeString": "int_const 0"
											},
											"value": "0"
										},
										"src": "282:8:3",
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										}
									},
									"falseBody": null,
									"id": 302,
									"nodeType": "IfStatement",
									"src": "278:69:3",
									"trueBody": {
										"id": 301,
										"nodeType": "Block",
										"src": "292:55:3",
										"statements": [
											{
												"expression": {
													"argumentTypes": null,
													"arguments": [],
													"expression": {
														"argumentTypes": [],
														"id": 298,
														"name": "revert",
														"nodeType": "Identifier",
														"overloadedDeclarations": [
															2942,
															2943
														],
														"referencedDeclaration": 2942,
														"src": "300:6:3",
														"typeDescriptions": {
															"typeIdentifier": "t_function_revert_pure$__$returns$__$",
															"typeString": "function () pure"
														}
													},
													"id": 299,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"kind": "functionCall",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "300:8:3",
													"typeDescriptions": {
														"typeIdentifier": "t_tuple$__$",
														"typeString": "tuple()"
													}
												},
												"id": 300,
												"nodeType": "ExpressionStatement",
												"src": "300:8:3"
											}
										]
									}
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 305,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"id": 303,
											"name": "htcIsHauled",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 274,
											"src": "353:11:3",
											"typeDescriptions": {
												"typeIdentifier": "t_bool",
												"typeString": "bool"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"hexValue": "74727565",
											"id": 304,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "bool",
											"lValueRequested": false,
											"nodeType": "Literal",
											"src": "367:4:3",
											"subdenomination": null,
											"typeDescriptions": {
												"typeIdentifier": "t_bool",
												"typeString": "bool"
											},
											"value": "true"
										},
										"src": "353:18:3",
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										}
									},
									"id": 306,
									"nodeType": "ExpressionStatement",
									"src": "353:18:3"
								}
							]
						},
						"documentation": null,
						"id": 308,
						"implemented": true,
						"isConstructor": false,
						"isDeclaredConst": false,
						"modifiers": [],
						"name": "sailAway",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 278,
							"nodeType": "ParameterList",
							"parameters": [],
							"src": "137:2:3"
						},
						"payable": false,
						"returnParameters": {
							"id": 279,
							"nodeType": "ParameterList",
							"parameters": [],
							"src": "147:0:3"
						},
						"scope": 564,
						"src": "120:256:3",
						"stateMutability": "nonpayable",
						"superFunction": null,
						"visibility": "public"
					},
					{
						"body": {
							"id": 322,
							"nodeType": "Block",
							"src": "409:121:3",
							"statements": [
								{
									"condition": {
										"argumentTypes": null,
										"commonType": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										},
										"id": 313,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftExpression": {
											"argumentTypes": null,
											"id": 311,
											"name": "anchor",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 277,
											"src": "419:6:3",
											"typeDescriptions": {
												"typeIdentifier": "t_address",
												"typeString": "address"
											}
										},
										"nodeType": "BinaryOperation",
										"operator": "!=",
										"rightExpression": {
											"argumentTypes": null,
											"hexValue": "30783030",
											"id": 312,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "number",
											"lValueRequested": false,
											"nodeType": "Literal",
											"src": "429:4:3",
											"subdenomination": null,
											"typeDescriptions": {
												"typeIdentifier": "t_rational_0_by_1",
												"typeString": "int_const 0"
											},
											"value": "0x00"
										},
										"src": "419:14:3",
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										}
									},
									"falseBody": null,
									"id": 321,
									"nodeType": "IfStatement",
									"src": "415:111:3",
									"trueBody": {
										"id": 320,
										"nodeType": "Block",
										"src": "435:91:3",
										"statements": [
											{
												"expression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"arguments": [],
															"expression": {
																"argumentTypes": [],
																"expression": {
																	"argumentTypes": null,
																	"id": 315,
																	"name": "anchor",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 277,
																	"src": "451:6:3",
																	"typeDescriptions": {
																		"typeIdentifier": "t_address",
																		"typeString": "address"
																	}
																},
																"id": 316,
																"isConstant": false,
																"isLValue": false,
																"isPure": false,
																"lValueRequested": false,
																"memberName": "call",
																"nodeType": "MemberAccess",
																"referencedDeclaration": null,
																"src": "451:11:3",
																"typeDescriptions": {
																	"typeIdentifier": "t_function_barecall_payable$__$returns$_t_bool_$",
																	"typeString": "function () payable returns (bool)"
																}
															},
															"id": 317,
															"isConstant": false,
															"isLValue": false,
															"isPure": false,
															"kind": "functionCall",
															"lValueRequested": false,
															"names": [],
															"nodeType": "FunctionCall",
															"src": "451:13:3",
															"typeDescriptions": {
																"typeIdentifier": "t_bool",
																"typeString": "bool"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_bool",
																"typeString": "bool"
															}
														],
														"id": 314,
														"name": "require",
														"nodeType": "Identifier",
														"overloadedDeclarations": [
															2940,
															2941
														],
														"referencedDeclaration": 2940,
														"src": "443:7:3",
														"typeDescriptions": {
															"typeIdentifier": "t_function_require_pure$_t_bool_$returns$__$",
															"typeString": "function (bool) pure"
														}
													},
													"id": 318,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"kind": "functionCall",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "443:22:3",
													"typeDescriptions": {
														"typeIdentifier": "t_tuple$__$",
														"typeString": "tuple()"
													}
												},
												"id": 319,
												"nodeType": "ExpressionStatement",
												"src": "443:22:3"
											}
										]
									}
								}
							]
						},
						"documentation": null,
						"id": 323,
						"implemented": true,
						"isConstructor": false,
						"isDeclaredConst": false,
						"modifiers": [],
						"name": "pullAnchor",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 309,
							"nodeType": "ParameterList",
							"parameters": [],
							"src": "399:2:3"
						},
						"payable": false,
						"returnParameters": {
							"id": 310,
							"nodeType": "ParameterList",
							"parameters": [],
							"src": "409:0:3"
						},
						"scope": 564,
						"src": "380:150:3",
						"stateMutability": "nonpayable",
						"superFunction": null,
						"visibility": "public"
					},
					{
						"body": {
							"id": 482,
							"nodeType": "Block",
							"src": "609:925:3",
							"statements": [
								{
									"expression": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"commonType": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												},
												"id": 336,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"leftExpression": {
													"argumentTypes": null,
													"id": 331,
													"name": "blockNumber",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 325,
													"src": "684:11:3",
													"typeDescriptions": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												},
												"nodeType": "BinaryOperation",
												"operator": ">",
												"rightExpression": {
													"argumentTypes": null,
													"commonType": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													},
													"id": 335,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"leftExpression": {
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 332,
															"name": "block",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 2927,
															"src": "698:5:3",
															"typeDescriptions": {
																"typeIdentifier": "t_magic_block",
																"typeString": "block"
															}
														},
														"id": 333,
														"isConstant": false,
														"isLValue": false,
														"isPure": false,
														"lValueRequested": false,
														"memberName": "number",
														"nodeType": "MemberAccess",
														"referencedDeclaration": null,
														"src": "698:12:3",
														"typeDescriptions": {
															"typeIdentifier": "t_uint256",
															"typeString": "uint256"
														}
													},
													"nodeType": "BinaryOperation",
													"operator": "+",
													"rightExpression": {
														"argumentTypes": null,
														"hexValue": "3530303030",
														"id": 334,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "number",
														"lValueRequested": false,
														"nodeType": "Literal",
														"src": "713:5:3",
														"subdenomination": null,
														"typeDescriptions": {
															"typeIdentifier": "t_rational_50000_by_1",
															"typeString": "int_const 50000"
														},
														"value": "50000"
													},
													"src": "698:20:3",
													"typeDescriptions": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												},
												"src": "684:34:3",
												"typeDescriptions": {
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											],
											"id": 330,
											"name": "require",
											"nodeType": "Identifier",
											"overloadedDeclarations": [
												2940,
												2941
											],
											"referencedDeclaration": 2940,
											"src": "676:7:3",
											"typeDescriptions": {
												"typeIdentifier": "t_function_require_pure$_t_bool_$returns$__$",
												"typeString": "function (bool) pure"
											}
										},
										"id": 337,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "676:43:3",
										"typeDescriptions": {
											"typeIdentifier": "t_tuple$__$",
											"typeString": "tuple()"
										}
									},
									"id": 338,
									"nodeType": "ExpressionStatement",
									"src": "676:43:3"
								},
								{
									"assignments": [],
									"declarations": [
										{
											"constant": false,
											"id": 343,
											"name": "a",
											"nodeType": "VariableDeclaration",
											"scope": 483,
											"src": "803:19:3",
											"stateVariable": false,
											"storageLocation": "memory",
											"typeDescriptions": {
												"typeIdentifier": "t_array$_t_uint256_$8_memory_ptr",
												"typeString": "uint256[8]"
											},
											"typeName": {
												"baseType": {
													"id": 341,
													"name": "uint256",
													"nodeType": "ElementaryTypeName",
													"src": "803:7:3",
													"typeDescriptions": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												},
												"id": 342,
												"length": {
													"argumentTypes": null,
													"hexValue": "38",
													"id": 340,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "811:1:3",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": null,
														"typeString": null
													},
													"value": "8"
												},
												"nodeType": "ArrayTypeName",
												"src": "803:10:3",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint256_$8_storage_ptr",
													"typeString": "uint256[8]"
												}
											},
											"value": null,
											"visibility": "internal"
										}
									],
									"id": 344,
									"initialValue": null,
									"nodeType": "VariableDeclarationStatement",
									"src": "803:19:3"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 349,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"id": 345,
												"name": "a",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 343,
												"src": "828:1:3",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint256_$8_memory_ptr",
													"typeString": "uint256[8] memory"
												}
											},
											"id": 347,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "30",
												"id": 346,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "830:1:3",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_0_by_1",
													"typeString": "int_const 0"
												},
												"value": "0"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "828:4:3",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"hexValue": "307836333030",
											"id": 348,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "number",
											"lValueRequested": false,
											"nodeType": "Literal",
											"src": "835:6:3",
											"subdenomination": null,
											"typeDescriptions": {
												"typeIdentifier": "t_rational_25344_by_1",
												"typeString": "int_const 25344"
											},
											"value": "0x6300"
										},
										"src": "828:13:3",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									},
									"id": 350,
									"nodeType": "ExpressionStatement",
									"src": "828:13:3"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 355,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"id": 351,
												"name": "a",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 343,
												"src": "847:1:3",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint256_$8_memory_ptr",
													"typeString": "uint256[8] memory"
												}
											},
											"id": 353,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "31",
												"id": 352,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "849:1:3",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_1_by_1",
													"typeString": "int_const 1"
												},
												"value": "1"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "847:4:3",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"id": 354,
											"name": "blockNumber",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 325,
											"src": "854:11:3",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"src": "847:18:3",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									},
									"id": 356,
									"nodeType": "ExpressionStatement",
									"src": "847:18:3"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 361,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"id": 357,
												"name": "a",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 343,
												"src": "871:1:3",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint256_$8_memory_ptr",
													"typeString": "uint256[8] memory"
												}
											},
											"id": 359,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "32",
												"id": 358,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "873:1:3",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_2_by_1",
													"typeString": "int_const 2"
												},
												"value": "2"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "871:4:3",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"hexValue": "30783433",
											"id": 360,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "number",
											"lValueRequested": false,
											"nodeType": "Literal",
											"src": "878:4:3",
											"subdenomination": null,
											"typeDescriptions": {
												"typeIdentifier": "t_rational_67_by_1",
												"typeString": "int_const 67"
											},
											"value": "0x43"
										},
										"src": "871:11:3",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									},
									"id": 362,
									"nodeType": "ExpressionStatement",
									"src": "871:11:3"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 367,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"id": 363,
												"name": "a",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 343,
												"src": "888:1:3",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint256_$8_memory_ptr",
													"typeString": "uint256[8] memory"
												}
											},
											"id": 365,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "33",
												"id": 364,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "890:1:3",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_3_by_1",
													"typeString": "int_const 3"
												},
												"value": "3"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "888:4:3",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"hexValue": "30783130",
											"id": 366,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "number",
											"lValueRequested": false,
											"nodeType": "Literal",
											"src": "895:4:3",
											"subdenomination": null,
											"typeDescriptions": {
												"typeIdentifier": "t_rational_16_by_1",
												"typeString": "int_const 16"
											},
											"value": "0x10"
										},
										"src": "888:11:3",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									},
									"id": 368,
									"nodeType": "ExpressionStatement",
									"src": "888:11:3"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 373,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"id": 369,
												"name": "a",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 343,
												"src": "905:1:3",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint256_$8_memory_ptr",
													"typeString": "uint256[8] memory"
												}
											},
											"id": 371,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "34",
												"id": 370,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "907:1:3",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_4_by_1",
													"typeString": "int_const 4"
												},
												"value": "4"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "905:4:3",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"hexValue": "30783538",
											"id": 372,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "number",
											"lValueRequested": false,
											"nodeType": "Literal",
											"src": "912:4:3",
											"subdenomination": null,
											"typeDescriptions": {
												"typeIdentifier": "t_rational_88_by_1",
												"typeString": "int_const 88"
											},
											"value": "0x58"
										},
										"src": "905:11:3",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									},
									"id": 374,
									"nodeType": "ExpressionStatement",
									"src": "905:11:3"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 379,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"id": 375,
												"name": "a",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 343,
												"src": "922:1:3",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint256_$8_memory_ptr",
													"typeString": "uint256[8] memory"
												}
											},
											"id": 377,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "35",
												"id": 376,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "924:1:3",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_5_by_1",
													"typeString": "int_const 5"
												},
												"value": "5"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "922:4:3",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"hexValue": "30783537",
											"id": 378,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "number",
											"lValueRequested": false,
											"nodeType": "Literal",
											"src": "929:4:3",
											"subdenomination": null,
											"typeDescriptions": {
												"typeIdentifier": "t_rational_87_by_1",
												"typeString": "int_const 87"
											},
											"value": "0x57"
										},
										"src": "922:11:3",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									},
									"id": 380,
									"nodeType": "ExpressionStatement",
									"src": "922:11:3"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 385,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"id": 381,
												"name": "a",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 343,
												"src": "939:1:3",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint256_$8_memory_ptr",
													"typeString": "uint256[8] memory"
												}
											},
											"id": 383,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "36",
												"id": 382,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "941:1:3",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_6_by_1",
													"typeString": "int_const 6"
												},
												"value": "6"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "939:4:3",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"hexValue": "30783333",
											"id": 384,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "number",
											"lValueRequested": false,
											"nodeType": "Literal",
											"src": "946:4:3",
											"subdenomination": null,
											"typeDescriptions": {
												"typeIdentifier": "t_rational_51_by_1",
												"typeString": "int_const 51"
											},
											"value": "0x33"
										},
										"src": "939:11:3",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									},
									"id": 386,
									"nodeType": "ExpressionStatement",
									"src": "939:11:3"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 391,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"id": 387,
												"name": "a",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 343,
												"src": "956:1:3",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint256_$8_memory_ptr",
													"typeString": "uint256[8] memory"
												}
											},
											"id": 389,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "37",
												"id": 388,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "958:1:3",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_7_by_1",
													"typeString": "int_const 7"
												},
												"value": "7"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "956:4:3",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"hexValue": "30786666",
											"id": 390,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "number",
											"lValueRequested": false,
											"nodeType": "Literal",
											"src": "963:4:3",
											"subdenomination": null,
											"typeDescriptions": {
												"typeIdentifier": "t_rational_255_by_1",
												"typeString": "int_const 255"
											},
											"value": "0xff"
										},
										"src": "956:11:3",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									},
									"id": 392,
									"nodeType": "ExpressionStatement",
									"src": "956:11:3"
								},
								{
									"assignments": [
										394
									],
									"declarations": [
										{
											"constant": false,
											"id": 394,
											"name": "code",
											"nodeType": "VariableDeclaration",
											"scope": 483,
											"src": "974:12:3",
											"stateVariable": false,
											"storageLocation": "default",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											},
											"typeName": {
												"id": 393,
												"name": "uint256",
												"nodeType": "ElementaryTypeName",
												"src": "974:7:3",
												"typeDescriptions": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												}
											},
											"value": null,
											"visibility": "internal"
										}
									],
									"id": 398,
									"initialValue": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"id": 396,
												"name": "a",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 343,
												"src": "998:1:3",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint256_$8_memory_ptr",
													"typeString": "uint256[8] memory"
												}
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_array$_t_uint256_$8_memory_ptr",
													"typeString": "uint256[8] memory"
												}
											],
											"id": 395,
											"name": "assemble",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 521,
											"src": "989:8:3",
											"typeDescriptions": {
												"typeIdentifier": "t_function_internal_pure$_t_array$_t_uint256_$8_memory_ptr_$returns$_t_uint256_$",
												"typeString": "function (uint256[8] memory) pure returns (uint256)"
											}
										},
										"id": 397,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "989:11:3",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									},
									"nodeType": "VariableDeclarationStatement",
									"src": "974:26:3"
								},
								{
									"assignments": [],
									"declarations": [
										{
											"constant": false,
											"id": 403,
											"name": "b",
											"nodeType": "VariableDeclaration",
											"scope": 483,
											"src": "1043:19:3",
											"stateVariable": false,
											"storageLocation": "memory",
											"typeDescriptions": {
												"typeIdentifier": "t_array$_t_uint256_$8_memory_ptr",
												"typeString": "uint256[8]"
											},
											"typeName": {
												"baseType": {
													"id": 401,
													"name": "uint256",
													"nodeType": "ElementaryTypeName",
													"src": "1043:7:3",
													"typeDescriptions": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												},
												"id": 402,
												"length": {
													"argumentTypes": null,
													"hexValue": "38",
													"id": 400,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "1051:1:3",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": null,
														"typeString": null
													},
													"value": "8"
												},
												"nodeType": "ArrayTypeName",
												"src": "1043:10:3",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint256_$8_storage_ptr",
													"typeString": "uint256[8]"
												}
											},
											"value": null,
											"visibility": "internal"
										}
									],
									"id": 404,
									"initialValue": null,
									"nodeType": "VariableDeclarationStatement",
									"src": "1043:19:3"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 409,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"id": 405,
												"name": "b",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 403,
												"src": "1068:1:3",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint256_$8_memory_ptr",
													"typeString": "uint256[8] memory"
												}
											},
											"id": 407,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "30",
												"id": 406,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "1070:1:3",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_0_by_1",
													"typeString": "int_const 0"
												},
												"value": "0"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "1068:4:3",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"hexValue": "30",
											"id": 408,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "number",
											"lValueRequested": false,
											"nodeType": "Literal",
											"src": "1075:1:3",
											"subdenomination": null,
											"typeDescriptions": {
												"typeIdentifier": "t_rational_0_by_1",
												"typeString": "int_const 0"
											},
											"value": "0"
										},
										"src": "1068:8:3",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									},
									"id": 410,
									"nodeType": "ExpressionStatement",
									"src": "1068:8:3"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 415,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"id": 411,
												"name": "b",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 403,
												"src": "1082:1:3",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint256_$8_memory_ptr",
													"typeString": "uint256[8] memory"
												}
											},
											"id": 413,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "31",
												"id": 412,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "1084:1:3",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_1_by_1",
													"typeString": "int_const 1"
												},
												"value": "1"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "1082:4:3",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"hexValue": "30783661",
											"id": 414,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "number",
											"lValueRequested": false,
											"nodeType": "Literal",
											"src": "1089:4:3",
											"subdenomination": null,
											"typeDescriptions": {
												"typeIdentifier": "t_rational_106_by_1",
												"typeString": "int_const 106"
											},
											"value": "0x6a"
										},
										"src": "1082:11:3",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									},
									"id": 416,
									"nodeType": "ExpressionStatement",
									"src": "1082:11:3"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 421,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"id": 417,
												"name": "b",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 403,
												"src": "1099:1:3",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint256_$8_memory_ptr",
													"typeString": "uint256[8] memory"
												}
											},
											"id": 419,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "32",
												"id": 418,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "1101:1:3",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_2_by_1",
													"typeString": "int_const 2"
												},
												"value": "2"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "1099:4:3",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"id": 420,
											"name": "code",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 394,
											"src": "1106:4:3",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"src": "1099:11:3",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									},
									"id": 422,
									"nodeType": "ExpressionStatement",
									"src": "1099:11:3"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 427,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"id": 423,
												"name": "b",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 403,
												"src": "1116:1:3",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint256_$8_memory_ptr",
													"typeString": "uint256[8] memory"
												}
											},
											"id": 425,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "33",
												"id": 424,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "1118:1:3",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_3_by_1",
													"typeString": "int_const 3"
												},
												"value": "3"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "1116:4:3",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"hexValue": "307836303030",
											"id": 426,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "number",
											"lValueRequested": false,
											"nodeType": "Literal",
											"src": "1123:6:3",
											"subdenomination": null,
											"typeDescriptions": {
												"typeIdentifier": "t_rational_24576_by_1",
												"typeString": "int_const 24576"
											},
											"value": "0x6000"
										},
										"src": "1116:13:3",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									},
									"id": 428,
									"nodeType": "ExpressionStatement",
									"src": "1116:13:3"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 433,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"id": 429,
												"name": "b",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 403,
												"src": "1135:1:3",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint256_$8_memory_ptr",
													"typeString": "uint256[8] memory"
												}
											},
											"id": 431,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "34",
												"id": 430,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "1137:1:3",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_4_by_1",
													"typeString": "int_const 4"
												},
												"value": "4"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "1135:4:3",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"hexValue": "30783532",
											"id": 432,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "number",
											"lValueRequested": false,
											"nodeType": "Literal",
											"src": "1142:4:3",
											"subdenomination": null,
											"typeDescriptions": {
												"typeIdentifier": "t_rational_82_by_1",
												"typeString": "int_const 82"
											},
											"value": "0x52"
										},
										"src": "1135:11:3",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									},
									"id": 434,
									"nodeType": "ExpressionStatement",
									"src": "1135:11:3"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 439,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"id": 435,
												"name": "b",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 403,
												"src": "1152:1:3",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint256_$8_memory_ptr",
													"typeString": "uint256[8] memory"
												}
											},
											"id": 437,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "35",
												"id": 436,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "1154:1:3",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_5_by_1",
													"typeString": "int_const 5"
												},
												"value": "5"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "1152:4:3",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"hexValue": "307836303062",
											"id": 438,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "number",
											"lValueRequested": false,
											"nodeType": "Literal",
											"src": "1159:6:3",
											"subdenomination": null,
											"typeDescriptions": {
												"typeIdentifier": "t_rational_24587_by_1",
												"typeString": "int_const 24587"
											},
											"value": "0x600b"
										},
										"src": "1152:13:3",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									},
									"id": 440,
									"nodeType": "ExpressionStatement",
									"src": "1152:13:3"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 445,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"id": 441,
												"name": "b",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 403,
												"src": "1171:1:3",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint256_$8_memory_ptr",
													"typeString": "uint256[8] memory"
												}
											},
											"id": 443,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "36",
												"id": 442,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "1173:1:3",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_6_by_1",
													"typeString": "int_const 6"
												},
												"value": "6"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "1171:4:3",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"hexValue": "307836303135",
											"id": 444,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "number",
											"lValueRequested": false,
											"nodeType": "Literal",
											"src": "1178:6:3",
											"subdenomination": null,
											"typeDescriptions": {
												"typeIdentifier": "t_rational_24597_by_1",
												"typeString": "int_const 24597"
											},
											"value": "0x6015"
										},
										"src": "1171:13:3",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									},
									"id": 446,
									"nodeType": "ExpressionStatement",
									"src": "1171:13:3"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 451,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"id": 447,
												"name": "b",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 403,
												"src": "1190:1:3",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint256_$8_memory_ptr",
													"typeString": "uint256[8] memory"
												}
											},
											"id": 449,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "37",
												"id": 448,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "1192:1:3",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_7_by_1",
													"typeString": "int_const 7"
												},
												"value": "7"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "1190:4:3",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"hexValue": "30786633",
											"id": 450,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "number",
											"lValueRequested": false,
											"nodeType": "Literal",
											"src": "1197:4:3",
											"subdenomination": null,
											"typeDescriptions": {
												"typeIdentifier": "t_rational_243_by_1",
												"typeString": "int_const 243"
											},
											"value": "0xf3"
										},
										"src": "1190:11:3",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									},
									"id": 452,
									"nodeType": "ExpressionStatement",
									"src": "1190:11:3"
								},
								{
									"assignments": [
										454
									],
									"declarations": [
										{
											"constant": false,
											"id": 454,
											"name": "initcode",
											"nodeType": "VariableDeclaration",
											"scope": 483,
											"src": "1208:16:3",
											"stateVariable": false,
											"storageLocation": "default",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											},
											"typeName": {
												"id": 453,
												"name": "uint256",
												"nodeType": "ElementaryTypeName",
												"src": "1208:7:3",
												"typeDescriptions": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												}
											},
											"value": null,
											"visibility": "internal"
										}
									],
									"id": 458,
									"initialValue": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"id": 456,
												"name": "b",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 403,
												"src": "1236:1:3",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint256_$8_memory_ptr",
													"typeString": "uint256[8] memory"
												}
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_array$_t_uint256_$8_memory_ptr",
													"typeString": "uint256[8] memory"
												}
											],
											"id": 455,
											"name": "assemble",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 521,
											"src": "1227:8:3",
											"typeDescriptions": {
												"typeIdentifier": "t_function_internal_pure$_t_array$_t_uint256_$8_memory_ptr_$returns$_t_uint256_$",
												"typeString": "function (uint256[8] memory) pure returns (uint256)"
											}
										},
										"id": 457,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "1227:11:3",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									},
									"nodeType": "VariableDeclarationStatement",
									"src": "1208:30:3"
								},
								{
									"assignments": [
										460
									],
									"declarations": [
										{
											"constant": false,
											"id": 460,
											"name": "sz",
											"nodeType": "VariableDeclaration",
											"scope": 483,
											"src": "1244:10:3",
											"stateVariable": false,
											"storageLocation": "default",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											},
											"typeName": {
												"id": 459,
												"name": "uint256",
												"nodeType": "ElementaryTypeName",
												"src": "1244:7:3",
												"typeDescriptions": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												}
											},
											"value": null,
											"visibility": "internal"
										}
									],
									"id": 464,
									"initialValue": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"id": 462,
												"name": "initcode",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 454,
												"src": "1265:8:3",
												"typeDescriptions": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												}
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												}
											],
											"id": 461,
											"name": "getSize",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 563,
											"src": "1257:7:3",
											"typeDescriptions": {
												"typeIdentifier": "t_function_internal_pure$_t_uint256_$returns$_t_uint256_$",
												"typeString": "function (uint256) pure returns (uint256)"
											}
										},
										"id": 463,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "1257:17:3",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									},
									"nodeType": "VariableDeclarationStatement",
									"src": "1244:30:3"
								},
								{
									"assignments": [
										466
									],
									"declarations": [
										{
											"constant": false,
											"id": 466,
											"name": "offset",
											"nodeType": "VariableDeclaration",
											"scope": 483,
											"src": "1280:14:3",
											"stateVariable": false,
											"storageLocation": "default",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											},
											"typeName": {
												"id": 465,
												"name": "uint256",
												"nodeType": "ElementaryTypeName",
												"src": "1280:7:3",
												"typeDescriptions": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												}
											},
											"value": null,
											"visibility": "internal"
										}
									],
									"id": 470,
									"initialValue": {
										"argumentTypes": null,
										"commonType": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										},
										"id": 469,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftExpression": {
											"argumentTypes": null,
											"hexValue": "3332",
											"id": 467,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "number",
											"lValueRequested": false,
											"nodeType": "Literal",
											"src": "1297:2:3",
											"subdenomination": null,
											"typeDescriptions": {
												"typeIdentifier": "t_rational_32_by_1",
												"typeString": "int_const 32"
											},
											"value": "32"
										},
										"nodeType": "BinaryOperation",
										"operator": "-",
										"rightExpression": {
											"argumentTypes": null,
											"id": 468,
											"name": "sz",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 460,
											"src": "1302:2:3",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"src": "1297:7:3",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									},
									"nodeType": "VariableDeclarationStatement",
									"src": "1280:24:3"
								},
								{
									"externalReferences": [
										{
											"initcode": {
												"declaration": 454,
												"isOffset": false,
												"isSlot": false,
												"src": "1405:8:3",
												"valueSize": 1
											}
										},
										{
											"addr": {
												"declaration": 328,
												"isOffset": false,
												"isSlot": false,
												"src": "1421:4:3",
												"valueSize": 1
											}
										},
										{
											"offset": {
												"declaration": 466,
												"isOffset": false,
												"isSlot": false,
												"src": "1466:6:3",
												"valueSize": 1
											}
										},
										{
											"sz": {
												"declaration": 460,
												"isOffset": false,
												"isSlot": false,
												"src": "1475:2:3",
												"valueSize": 1
											}
										}
									],
									"id": 471,
									"nodeType": "InlineAssembly",
									"operations": "{\n    let solidity_free_mem_ptr := mload(0x40)\n    mstore(solidity_free_mem_ptr, initcode)\n    addr := create(0, add(solidity_free_mem_ptr, offset), sz)\n}",
									"src": "1311:186:3"
								},
								{
									"expression": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"commonType": {
													"typeIdentifier": "t_address",
													"typeString": "address"
												},
												"id": 475,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"leftExpression": {
													"argumentTypes": null,
													"id": 473,
													"name": "addr",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 328,
													"src": "1498:4:3",
													"typeDescriptions": {
														"typeIdentifier": "t_address",
														"typeString": "address"
													}
												},
												"nodeType": "BinaryOperation",
												"operator": "!=",
												"rightExpression": {
													"argumentTypes": null,
													"hexValue": "307830",
													"id": 474,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "1506:3:3",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_0_by_1",
														"typeString": "int_const 0"
													},
													"value": "0x0"
												},
												"src": "1498:11:3",
												"typeDescriptions": {
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											],
											"id": 472,
											"name": "require",
											"nodeType": "Identifier",
											"overloadedDeclarations": [
												2940,
												2941
											],
											"referencedDeclaration": 2940,
											"src": "1490:7:3",
											"typeDescriptions": {
												"typeIdentifier": "t_function_require_pure$_t_bool_$returns$__$",
												"typeString": "function (bool) pure"
											}
										},
										"id": 476,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "1490:20:3",
										"typeDescriptions": {
											"typeIdentifier": "t_tuple$__$",
											"typeString": "tuple()"
										}
									},
									"id": 477,
									"nodeType": "ExpressionStatement",
									"src": "1490:20:3"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 480,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"id": 478,
											"name": "anchor",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 277,
											"src": "1516:6:3",
											"typeDescriptions": {
												"typeIdentifier": "t_address",
												"typeString": "address"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"id": 479,
											"name": "addr",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 328,
											"src": "1525:4:3",
											"typeDescriptions": {
												"typeIdentifier": "t_address",
												"typeString": "address"
											}
										},
										"src": "1516:13:3",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"id": 481,
									"nodeType": "ExpressionStatement",
									"src": "1516:13:3"
								}
							]
						},
						"documentation": null,
						"id": 483,
						"implemented": true,
						"isConstructor": false,
						"isDeclaredConst": false,
						"modifiers": [],
						"name": "dropShipAnchor",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 326,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 325,
									"name": "blockNumber",
									"nodeType": "VariableDeclaration",
									"scope": 483,
									"src": "558:19:3",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_uint256",
										"typeString": "uint256"
									},
									"typeName": {
										"id": 324,
										"name": "uint256",
										"nodeType": "ElementaryTypeName",
										"src": "558:7:3",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "557:21:3"
						},
						"payable": false,
						"returnParameters": {
							"id": 329,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 328,
									"name": "addr",
									"nodeType": "VariableDeclaration",
									"scope": 483,
									"src": "595:12:3",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_address",
										"typeString": "address"
									},
									"typeName": {
										"id": 327,
										"name": "address",
										"nodeType": "ElementaryTypeName",
										"src": "595:7:3",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "594:14:3"
						},
						"scope": 564,
						"src": "534:1000:3",
						"stateMutability": "nonpayable",
						"superFunction": null,
						"visibility": "public"
					},
					{
						"body": {
							"id": 520,
							"nodeType": "Block",
							"src": "1659:113:3",
							"statements": [
								{
									"body": {
										"id": 518,
										"nodeType": "Block",
										"src": "1709:59:3",
										"statements": [
											{
												"expression": {
													"argumentTypes": null,
													"id": 516,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"leftHandSide": {
														"argumentTypes": null,
														"id": 503,
														"name": "code",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 490,
														"src": "1717:4:3",
														"typeDescriptions": {
															"typeIdentifier": "t_uint256",
															"typeString": "uint256"
														}
													},
													"nodeType": "Assignment",
													"operator": "^=",
													"rightHandSide": {
														"argumentTypes": null,
														"commonType": {
															"typeIdentifier": "t_uint256",
															"typeString": "uint256"
														},
														"id": 515,
														"isConstant": false,
														"isLValue": false,
														"isPure": false,
														"lValueRequested": false,
														"leftExpression": {
															"argumentTypes": null,
															"baseExpression": {
																"argumentTypes": null,
																"id": 504,
																"name": "chunks",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 487,
																"src": "1725:6:3",
																"typeDescriptions": {
																	"typeIdentifier": "t_array$_t_uint256_$8_memory_ptr",
																	"typeString": "uint256[8] memory"
																}
															},
															"id": 508,
															"indexExpression": {
																"argumentTypes": null,
																"commonType": {
																	"typeIdentifier": "t_uint256",
																	"typeString": "uint256"
																},
																"id": 507,
																"isConstant": false,
																"isLValue": false,
																"isPure": false,
																"lValueRequested": false,
																"leftExpression": {
																	"argumentTypes": null,
																	"id": 505,
																	"name": "i",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 493,
																	"src": "1732:1:3",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint256",
																		"typeString": "uint256"
																	}
																},
																"nodeType": "BinaryOperation",
																"operator": "-",
																"rightExpression": {
																	"argumentTypes": null,
																	"hexValue": "31",
																	"id": 506,
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": true,
																	"kind": "number",
																	"lValueRequested": false,
																	"nodeType": "Literal",
																	"src": "1736:1:3",
																	"subdenomination": null,
																	"typeDescriptions": {
																		"typeIdentifier": "t_rational_1_by_1",
																		"typeString": "int_const 1"
																	},
																	"value": "1"
																},
																"src": "1732:5:3",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint256",
																	"typeString": "uint256"
																}
															},
															"isConstant": false,
															"isLValue": true,
															"isPure": false,
															"lValueRequested": false,
															"nodeType": "IndexAccess",
															"src": "1725:13:3",
															"typeDescriptions": {
																"typeIdentifier": "t_uint256",
																"typeString": "uint256"
															}
														},
														"nodeType": "BinaryOperation",
														"operator": "<<",
														"rightExpression": {
															"argumentTypes": null,
															"components": [
																{
																	"argumentTypes": null,
																	"commonType": {
																		"typeIdentifier": "t_uint256",
																		"typeString": "uint256"
																	},
																	"id": 513,
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": false,
																	"lValueRequested": false,
																	"leftExpression": {
																		"argumentTypes": null,
																		"hexValue": "38",
																		"id": 509,
																		"isConstant": false,
																		"isLValue": false,
																		"isPure": true,
																		"kind": "number",
																		"lValueRequested": false,
																		"nodeType": "Literal",
																		"src": "1743:1:3",
																		"subdenomination": null,
																		"typeDescriptions": {
																			"typeIdentifier": "t_rational_8_by_1",
																			"typeString": "int_const 8"
																		},
																		"value": "8"
																	},
																	"nodeType": "BinaryOperation",
																	"operator": "*",
																	"rightExpression": {
																		"argumentTypes": null,
																		"arguments": [
																			{
																				"argumentTypes": null,
																				"id": 511,
																				"name": "code",
																				"nodeType": "Identifier",
																				"overloadedDeclarations": [],
																				"referencedDeclaration": 490,
																				"src": "1755:4:3",
																				"typeDescriptions": {
																					"typeIdentifier": "t_uint256",
																					"typeString": "uint256"
																				}
																			}
																		],
																		"expression": {
																			"argumentTypes": [
																				{
																					"typeIdentifier": "t_uint256",
																					"typeString": "uint256"
																				}
																			],
																			"id": 510,
																			"name": "getSize",
																			"nodeType": "Identifier",
																			"overloadedDeclarations": [],
																			"referencedDeclaration": 563,
																			"src": "1747:7:3",
																			"typeDescriptions": {
																				"typeIdentifier": "t_function_internal_pure$_t_uint256_$returns$_t_uint256_$",
																				"typeString": "function (uint256) pure returns (uint256)"
																			}
																		},
																		"id": 512,
																		"isConstant": false,
																		"isLValue": false,
																		"isPure": false,
																		"kind": "functionCall",
																		"lValueRequested": false,
																		"names": [],
																		"nodeType": "FunctionCall",
																		"src": "1747:13:3",
																		"typeDescriptions": {
																			"typeIdentifier": "t_uint256",
																			"typeString": "uint256"
																		}
																	},
																	"src": "1743:17:3",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint256",
																		"typeString": "uint256"
																	}
																}
															],
															"id": 514,
															"isConstant": false,
															"isInlineArray": false,
															"isLValue": false,
															"isPure": false,
															"lValueRequested": false,
															"nodeType": "TupleExpression",
															"src": "1742:19:3",
															"typeDescriptions": {
																"typeIdentifier": "t_uint256",
																"typeString": "uint256"
															}
														},
														"src": "1725:36:3",
														"typeDescriptions": {
															"typeIdentifier": "t_uint256",
															"typeString": "uint256"
														}
													},
													"src": "1717:44:3",
													"typeDescriptions": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												},
												"id": 517,
												"nodeType": "ExpressionStatement",
												"src": "1717:44:3"
											}
										]
									},
									"condition": {
										"argumentTypes": null,
										"commonType": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										},
										"id": 499,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftExpression": {
											"argumentTypes": null,
											"id": 497,
											"name": "i",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 493,
											"src": "1697:1:3",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"nodeType": "BinaryOperation",
										"operator": ">",
										"rightExpression": {
											"argumentTypes": null,
											"hexValue": "30",
											"id": 498,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "number",
											"lValueRequested": false,
											"nodeType": "Literal",
											"src": "1701:1:3",
											"subdenomination": null,
											"typeDescriptions": {
												"typeIdentifier": "t_rational_0_by_1",
												"typeString": "int_const 0"
											},
											"value": "0"
										},
										"src": "1697:5:3",
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										}
									},
									"id": 519,
									"initializationExpression": {
										"assignments": [
											493
										],
										"declarations": [
											{
												"constant": false,
												"id": 493,
												"name": "i",
												"nodeType": "VariableDeclaration",
												"scope": 521,
												"src": "1670:9:3",
												"stateVariable": false,
												"storageLocation": "default",
												"typeDescriptions": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												},
												"typeName": {
													"id": 492,
													"name": "uint256",
													"nodeType": "ElementaryTypeName",
													"src": "1670:7:3",
													"typeDescriptions": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												},
												"value": null,
												"visibility": "internal"
											}
										],
										"id": 496,
										"initialValue": {
											"argumentTypes": null,
											"expression": {
												"argumentTypes": null,
												"id": 494,
												"name": "chunks",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 487,
												"src": "1682:6:3",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint256_$8_memory_ptr",
													"typeString": "uint256[8] memory"
												}
											},
											"id": 495,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"memberName": "length",
											"nodeType": "MemberAccess",
											"referencedDeclaration": null,
											"src": "1682:13:3",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"nodeType": "VariableDeclarationStatement",
										"src": "1670:25:3"
									},
									"loopExpression": {
										"expression": {
											"argumentTypes": null,
											"id": 501,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"nodeType": "UnaryOperation",
											"operator": "--",
											"prefix": false,
											"src": "1704:3:3",
											"subExpression": {
												"argumentTypes": null,
												"id": 500,
												"name": "i",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 493,
												"src": "1704:1:3",
												"typeDescriptions": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												}
											},
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"id": 502,
										"nodeType": "ExpressionStatement",
										"src": "1704:3:3"
									},
									"nodeType": "ForStatement",
									"src": "1665:103:3"
								}
							]
						},
						"documentation": "////////////// HELPERS /////////////////",
						"id": 521,
						"implemented": true,
						"isConstructor": false,
						"isDeclaredConst": true,
						"modifiers": [],
						"name": "assemble",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 488,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 487,
									"name": "chunks",
									"nodeType": "VariableDeclaration",
									"scope": 521,
									"src": "1603:17:3",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_array$_t_uint256_$8_memory_ptr",
										"typeString": "uint256[8]"
									},
									"typeName": {
										"baseType": {
											"id": 484,
											"name": "uint256",
											"nodeType": "ElementaryTypeName",
											"src": "1603:7:3",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"id": 486,
										"length": {
											"argumentTypes": null,
											"hexValue": "38",
											"id": 485,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"kind": "number",
											"lValueRequested": false,
											"nodeType": "Literal",
											"src": "1611:1:3",
											"subdenomination": null,
											"typeDescriptions": {
												"typeIdentifier": null,
												"typeString": null
											},
											"value": "8"
										},
										"nodeType": "ArrayTypeName",
										"src": "1603:10:3",
										"typeDescriptions": {
											"typeIdentifier": "t_array$_t_uint256_$8_storage_ptr",
											"typeString": "uint256[8]"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "1602:19:3"
						},
						"payable": false,
						"returnParameters": {
							"id": 491,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 490,
									"name": "code",
									"nodeType": "VariableDeclaration",
									"scope": 521,
									"src": "1645:12:3",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_uint256",
										"typeString": "uint256"
									},
									"typeName": {
										"id": 489,
										"name": "uint256",
										"nodeType": "ElementaryTypeName",
										"src": "1645:7:3",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "1644:14:3"
						},
						"scope": 564,
						"src": "1585:187:3",
						"stateMutability": "pure",
						"superFunction": null,
						"visibility": "internal"
					},
					{
						"body": {
							"id": 562,
							"nodeType": "Block",
							"src": "1840:212:3",
							"statements": [
								{
									"assignments": [
										529
									],
									"declarations": [
										{
											"constant": false,
											"id": 529,
											"name": "b",
											"nodeType": "VariableDeclaration",
											"scope": 563,
											"src": "1846:14:3",
											"stateVariable": false,
											"storageLocation": "memory",
											"typeDescriptions": {
												"typeIdentifier": "t_bytes_memory_ptr",
												"typeString": "bytes"
											},
											"typeName": {
												"id": 528,
												"name": "bytes",
												"nodeType": "ElementaryTypeName",
												"src": "1846:5:3",
												"typeDescriptions": {
													"typeIdentifier": "t_bytes_storage_ptr",
													"typeString": "bytes"
												}
											},
											"value": null,
											"visibility": "internal"
										}
									],
									"id": 534,
									"initialValue": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"hexValue": "3332",
												"id": 532,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "1873:2:3",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_32_by_1",
													"typeString": "int_const 32"
												},
												"value": "32"
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_rational_32_by_1",
													"typeString": "int_const 32"
												}
											],
											"id": 531,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"lValueRequested": false,
											"nodeType": "NewExpression",
											"src": "1863:9:3",
											"typeDescriptions": {
												"typeIdentifier": "t_function_objectcreation_pure$_t_uint256_$returns$_t_bytes_memory_$",
												"typeString": "function (uint256) pure returns (bytes memory)"
											},
											"typeName": {
												"id": 530,
												"name": "bytes",
												"nodeType": "ElementaryTypeName",
												"src": "1867:5:3",
												"typeDescriptions": {
													"typeIdentifier": "t_bytes_storage_ptr",
													"typeString": "bytes"
												}
											}
										},
										"id": 533,
										"isConstant": false,
										"isLValue": false,
										"isPure": true,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "1863:13:3",
										"typeDescriptions": {
											"typeIdentifier": "t_bytes_memory",
											"typeString": "bytes memory"
										}
									},
									"nodeType": "VariableDeclarationStatement",
									"src": "1846:30:3"
								},
								{
									"externalReferences": [
										{
											"chunk": {
												"declaration": 523,
												"isOffset": false,
												"isSlot": false,
												"src": "1918:5:3",
												"valueSize": 1
											}
										},
										{
											"b": {
												"declaration": 529,
												"isOffset": false,
												"isSlot": false,
												"src": "1910:1:3",
												"valueSize": 1
											}
										}
									],
									"id": 535,
									"nodeType": "InlineAssembly",
									"operations": "{\n    mstore(add(b, 32), chunk)\n}",
									"src": "1882:56:3"
								},
								{
									"body": {
										"id": 558,
										"nodeType": "Block",
										"src": "1973:61:3",
										"statements": [
											{
												"condition": {
													"argumentTypes": null,
													"commonType": {
														"typeIdentifier": "t_bytes1",
														"typeString": "bytes1"
													},
													"id": 551,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"leftExpression": {
														"argumentTypes": null,
														"baseExpression": {
															"argumentTypes": null,
															"id": 547,
															"name": "b",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 529,
															"src": "1985:1:3",
															"typeDescriptions": {
																"typeIdentifier": "t_bytes_memory_ptr",
																"typeString": "bytes memory"
															}
														},
														"id": 549,
														"indexExpression": {
															"argumentTypes": null,
															"id": 548,
															"name": "i",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 537,
															"src": "1987:1:3",
															"typeDescriptions": {
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															}
														},
														"isConstant": false,
														"isLValue": true,
														"isPure": false,
														"lValueRequested": false,
														"nodeType": "IndexAccess",
														"src": "1985:4:3",
														"typeDescriptions": {
															"typeIdentifier": "t_bytes1",
															"typeString": "bytes1"
														}
													},
													"nodeType": "BinaryOperation",
													"operator": "!=",
													"rightExpression": {
														"argumentTypes": null,
														"hexValue": "30",
														"id": 550,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "number",
														"lValueRequested": false,
														"nodeType": "Literal",
														"src": "1993:1:3",
														"subdenomination": null,
														"typeDescriptions": {
															"typeIdentifier": "t_rational_0_by_1",
															"typeString": "int_const 0"
														},
														"value": "0"
													},
													"src": "1985:9:3",
													"typeDescriptions": {
														"typeIdentifier": "t_bool",
														"typeString": "bool"
													}
												},
												"falseBody": null,
												"id": 557,
												"nodeType": "IfStatement",
												"src": "1981:47:3",
												"trueBody": {
													"id": 556,
													"nodeType": "Block",
													"src": "1996:32:3",
													"statements": [
														{
															"expression": {
																"argumentTypes": null,
																"commonType": {
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																},
																"id": 554,
																"isConstant": false,
																"isLValue": false,
																"isPure": false,
																"lValueRequested": false,
																"leftExpression": {
																	"argumentTypes": null,
																	"hexValue": "3332",
																	"id": 552,
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": true,
																	"kind": "number",
																	"lValueRequested": false,
																	"nodeType": "Literal",
																	"src": "2013:2:3",
																	"subdenomination": null,
																	"typeDescriptions": {
																		"typeIdentifier": "t_rational_32_by_1",
																		"typeString": "int_const 32"
																	},
																	"value": "32"
																},
																"nodeType": "BinaryOperation",
																"operator": "-",
																"rightExpression": {
																	"argumentTypes": null,
																	"id": 553,
																	"name": "i",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 537,
																	"src": "2018:1:3",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	}
																},
																"src": "2013:6:3",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																}
															},
															"functionReturnParameters": 527,
															"id": 555,
															"nodeType": "Return",
															"src": "2006:13:3"
														}
													]
												}
											}
										]
									},
									"condition": {
										"argumentTypes": null,
										"commonType": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										},
										"id": 543,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftExpression": {
											"argumentTypes": null,
											"id": 540,
											"name": "i",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 537,
											"src": "1954:1:3",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "BinaryOperation",
										"operator": "<",
										"rightExpression": {
											"argumentTypes": null,
											"expression": {
												"argumentTypes": null,
												"id": 541,
												"name": "b",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 529,
												"src": "1958:1:3",
												"typeDescriptions": {
													"typeIdentifier": "t_bytes_memory_ptr",
													"typeString": "bytes memory"
												}
											},
											"id": 542,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"memberName": "length",
											"nodeType": "MemberAccess",
											"referencedDeclaration": null,
											"src": "1958:8:3",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"src": "1954:12:3",
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										}
									},
									"id": 559,
									"initializationExpression": {
										"assignments": [
											537
										],
										"declarations": [
											{
												"constant": false,
												"id": 537,
												"name": "i",
												"nodeType": "VariableDeclaration",
												"scope": 563,
												"src": "1940:8:3",
												"stateVariable": false,
												"storageLocation": "default",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												},
												"typeName": {
													"id": 536,
													"name": "uint32",
													"nodeType": "ElementaryTypeName",
													"src": "1940:6:3",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"value": null,
												"visibility": "internal"
											}
										],
										"id": 539,
										"initialValue": {
											"argumentTypes": null,
											"hexValue": "30",
											"id": 538,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "number",
											"lValueRequested": false,
											"nodeType": "Literal",
											"src": "1951:1:3",
											"subdenomination": null,
											"typeDescriptions": {
												"typeIdentifier": "t_rational_0_by_1",
												"typeString": "int_const 0"
											},
											"value": "0"
										},
										"nodeType": "VariableDeclarationStatement",
										"src": "1940:12:3"
									},
									"loopExpression": {
										"expression": {
											"argumentTypes": null,
											"id": 545,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"nodeType": "UnaryOperation",
											"operator": "++",
											"prefix": false,
											"src": "1968:3:3",
											"subExpression": {
												"argumentTypes": null,
												"id": 544,
												"name": "i",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 537,
												"src": "1968:1:3",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 546,
										"nodeType": "ExpressionStatement",
										"src": "1968:3:3"
									},
									"nodeType": "ForStatement",
									"src": "1935:99:3"
								},
								{
									"expression": {
										"argumentTypes": null,
										"hexValue": "30",
										"id": 560,
										"isConstant": false,
										"isLValue": false,
										"isPure": true,
										"kind": "number",
										"lValueRequested": false,
										"nodeType": "Literal",
										"src": "2046:1:3",
										"subdenomination": null,
										"typeDescriptions": {
											"typeIdentifier": "t_rational_0_by_1",
											"typeString": "int_const 0"
										},
										"value": "0"
									},
									"functionReturnParameters": 527,
									"id": 561,
									"nodeType": "Return",
									"src": "2039:8:3"
								}
							]
						},
						"documentation": null,
						"id": 563,
						"implemented": true,
						"isConstructor": false,
						"isDeclaredConst": true,
						"modifiers": [],
						"name": "getSize",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 524,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 523,
									"name": "chunk",
									"nodeType": "VariableDeclaration",
									"scope": 563,
									"src": "1793:13:3",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_uint256",
										"typeString": "uint256"
									},
									"typeName": {
										"id": 522,
										"name": "uint256",
										"nodeType": "ElementaryTypeName",
										"src": "1793:7:3",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "1792:15:3"
						},
						"payable": false,
						"returnParameters": {
							"id": 527,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 526,
									"name": "",
									"nodeType": "VariableDeclaration",
									"scope": 563,
									"src": "1831:7:3",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_uint256",
										"typeString": "uint256"
									},
									"typeName": {
										"id": 525,
										"name": "uint256",
										"nodeType": "ElementaryTypeName",
										"src": "1831:7:3",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "1830:9:3"
						},
						"scope": 564,
						"src": "1776:276:3",
						"stateMutability": "pure",
						"superFunction": null,
						"visibility": "internal"
					}
				],
				"scope": 565,
				"src": "26:2028:3"
			}
		],
		"src": "0:2055:3"
	},
	"compiler": {
		"name": "solc",
		"version": "0.4.24+commit.e67f0147.Emscripten.clang"
	},
	"networks": {},
	"schemaVersion": "2.0.1",
	"updatedAt": "2020-10-22T15:28:26.794Z"
};


//////////////////
// WEBPACK FOOTER
// ./build/contracts/CrosslinkShip.json
// module id = 1027
// module chunks = 0